import $ from 'jquery'
import { handleFile, replayFromSite } from "../game2.js";
import {
  resolvePlayerName,
  summarizePasses,
  summarizeDirectionalPasses,
  summarizeKicks,
  summarizeSimpleList,
  summarizeSaves,
  summarizeDuels,
  summarizeRebounds,
  summarizeClearances,
  summarizeClearanceRecoveries,
  extractShotXg,
  estimateShotXg,
  isShotOnTarget,
  extractSavedBy,
  buildAdvancedPlayerStats
} from '../utils/gameStatsHelpers';
import {
  canonicalPlayerKey,
  inferTeamsFromMatch,
  normalizeTeamLabel
} from '../utils/teamUtils';
import { isFflSevenAsideMatch } from '../utils/fflUtils';
import LoadingScreen from "./LoadingScreen";
import { useSelector, useDispatch } from "react-redux";
import { setMainMode, setUserUploaded } from "../slices/mainModeSlice";
import { setDivStyle, setStats, setPlayerList, setPlayerPos, clearStats, setConnectHalves, setRedTeamName, setBlueTeamName, setConnectedHalves } from "../slices/gameStatsSlice";
import GameStats from "./game stats/GameStatsPro";
import ReplayPlayerOverlay from "./game stats/ReplayPlayerOverlay";

import computePlayerRatingsForMatch from './game stats/playerRatingsShared';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { createPortal } from 'react-dom';
import ReplaysList from "./replays/ReplaysList";
import { setReplays, setReplaysLoaded, setReplaysType, setLoadingMore, addMoreReplays, incrementReplayViews } from "../slices/replaysSlice";
import { openModal } from "./Modal";
import Downloading from "./Downloading";
import { startCanvasRecording } from '../utils/recorder'
import haxgptLogo from '../images/8ad689c6457700b8753b50f43df29eff-removebg-preview.png';

const HOME_FEATURES = [
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
    title: 'Instant breakdown',
    description: 'Upload a replay to see goals, passes, touches, and possession visualised in seconds.'
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
    title: 'Advanced filters',
    description: 'Surface the matches you care about with player, team, stadium, and date filters.'
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
        <line x1="7" y1="2" x2="7" y2="22" />
        <line x1="17" y1="2" x2="17" y2="22" />
        <line x1="2" y1="12" x2="22" y2="12" />
      </svg>
    ),
    title: 'Shareable insights',
    description: 'Review stats with teammates or export highlights using the built-in clip recorder.'
  }
];

const POSITION_HEATMAP_ROWS = 8;
const POSITION_HEATMAP_COLS = 12;

export function showStats() { }
export function setGameStats() { }
export function dispatchPlayerList() { }
export function dispatchPlayerPos() { }
export function dispatchClearStats() { }
export function sendSocketMessage() { }
export function sendMessageExp() { }
export function search4Replays() { }
export function checkParamsExp() { }
export function changeTeamNames() { }
export function loadMoreReplays() { }
export function markClipReady() { }
export function clearClipReady() { }

var queryMessage = {};
var replayData = [];
var waitingForStats = true;
var replayIdToSend;
var startedPlayback = false;
var startedReplayId = null;
var headlessReplayContext = null;

export function setHeadlessReplayContext(context = {}) {
  const sanitized = {
    replayId: context.replayId || null,
    replayName: context.replayName || null,
    lastModified: context.lastModified || null
  };
  headlessReplayContext = sanitized;
  if (sanitized.replayId) replayIdToSend = sanitized.replayId;
}
export function getRecordingServerBase() {
  if (typeof window !== 'undefined' && window.location.origin) {
    const configured = process.env.REACT_APP_RECORDING_SERVER_URL;
    if (!configured || configured.includes('maghrebsmp.fun') || configured === window.location.origin) {
      return window.location.origin;
    }
    return configured;
  }
  return process.env.REACT_APP_RECORDING_SERVER_URL || '';
}
function incrementViews(id) {
  try {
    const base = getRecordingServerBase();
    if (!base || !id) return;
    const url = base.replace(/\/$/, '') + '/api/views/' + encodeURIComponent(id) + '/increment';
    fetch(url, { method: 'POST' }).catch(() => {});
  } catch (_) {}
}
function postStatsHTTP(id, payload) {
  try {
    const base = getRecordingServerBase();
    if (!base || !id || !payload) return;
    const url = base.replace(/\/$/, '') + '/api/stats/' + encodeURIComponent(id);
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, replayId: id })
    }).catch(() => {});
  } catch (_) {}
}
var pendingUpload = null; // holds ArrayBuffer when WS isn't open yet

function deepCloneValue(value, fallback) {
  if (value === undefined) return fallback;
  if (typeof structuredClone === 'function') {
    try { return structuredClone(value); } catch (_) {}
  }
  try { return JSON.parse(JSON.stringify(value)); } catch (_) { return fallback; }
}

function cloneArrayValue(value) {
  const cloned = deepCloneValue(value, []);
  return Array.isArray(cloned) ? cloned : [];
}

function toFiniteNumberOr(value, fallback = 0) {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}

function normalizeMimeType(value, fallback = 'video/webm') {
  if (typeof value === 'string') {
    const lower = value.toLowerCase();
    if (lower.startsWith('video/webm')) return 'video/webm';
    if (lower.startsWith('video/mp4')) return 'video/mp4';
  }
  return value || fallback;
}

function clampNumber(value, min, max) {
  if (!Number.isFinite(value)) return min;
  return Math.max(min, Math.min(max, value));
}

function toFiniteOrNull(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function deriveAverage(primary, sum, samples) {
  const direct = toFiniteOrNull(primary);
  if (direct !== null) return direct;
  const sumVal = toFiniteOrNull(sum);
  const sampleVal = toFiniteOrNull(samples);
  if (sumVal !== null && sampleVal !== null && sampleVal > 0) {
    return sumVal / sampleVal;
  }
  return null;
}

function deriveSpanRatio(ratio, minValue, maxValue, size) {
  const direct = toFiniteOrNull(ratio);
  if (direct !== null) return clampNumber(direct, 0, 1);
  const minVal = toFiniteOrNull(minValue);
  const maxVal = toFiniteOrNull(maxValue);
  const dimension = toFiniteOrNull(size);
  if (minVal !== null && maxVal !== null && dimension !== null && dimension > 0) {
    return clampNumber(Math.abs(maxVal - minVal) / dimension, 0, 1);
  }
  return null;
}

function deriveHeatmapShares(entry, orientation, width, height) {
  const heatmap = Array.isArray(entry?.heatmap) ? entry.heatmap : null;
  if (!heatmap || !heatmap.length) return null;
  const rows = heatmap.length;
  const firstRow = heatmap.find((row) => Array.isArray(row) && row.length);
  const cols = firstRow ? firstRow.length : 0;
  if (!cols) return null;
  let total = 0;
  let wideCount = 0;
  let cornerCount = 0;
  for (let r = 0; r < rows; r += 1) {
    const row = Array.isArray(heatmap[r]) ? heatmap[r] : [];
    for (let c = 0; c < cols; c += 1) {
      const count = Number(row[c]);
      if (!Number.isFinite(count) || count <= 0) continue;
      total += count;
      const normalizedX = ((c + 0.5) / cols - 0.5) * width;
      const orientedX = normalizedX * orientation;
      const normalizedY = ((r + 0.5) / rows - 0.5) * height;
      if (Math.abs(normalizedY) >= height * 0.25) wideCount += count;
      if (orientedX >= width * 0.3 && Math.abs(normalizedY) >= height * 0.35) cornerCount += count;
    }
  }
  if (total <= 0) return null;
  return {
    wideShare: clampNumber(wideCount / total, 0, 1),
    cornerShare: clampNumber(cornerCount / total, 0, 1)
  };
}


function createBaseMetrics(teamKey = null) {
  return {
    goals: 0,
    playedTicks: 0,
    assists: 0,
    xg: 0,
    xgOnTarget: 0,
    shotsTotal: 0,
    shotsOnTarget: 0,
    shotsOffTarget: 0,
    passesCompleted: 0,
    passAttempts: 0,
    passCompletionRate: 0,
    passesPerMinute: 0,
    passesForward: 0,
    passesLateral: 0,
    passesBackward: 0,
    keyPasses: 0,
    progressivePasses: 0,
    progressiveDistance: 0,
    finalThirdEntries: 0,
    touches: 0,
    pressuredTouches: 0,
    touchesPerMinute: 0,
    pressureRelief: 0,
    duelWins: 0,
    duelLosses: 0,
    duelTotal: 0,
    duelWinRate: 0,
    saves: 0,
    clearances: 0,
    clearanceRecoveries: 0,
    rebounds: 0,
    interceptions: 0,
    recoveries: 0,
    finalThirdRecoveries: 0,
    counterRuns: 0,
    sweeperActions: 0,
    xgPrevented: 0,
    goalsConceded: 0,
    possessionTouches: 0,
    forcedTurnovers: 0,
    turnoversCommitted: 0,
    turnoverTouches: 0,
    dangerousTurnovers: 0,
    positionDepth: null,
    positionLateral: null,
    positionWideShare: null,
    positionCornerShare: null,
    normalizedDepth: null,
    normalizedLateral: null,
    widthShare: null,
    heightShare: null,
    samples: 0,
    teamKey,
    position: null,
    role: null,
    summary: null
  };
}

function buildPositionSnapshot(entry, teamKey, match) {
  if (!entry || typeof entry !== 'object') return null;
  const stadiumWidth = Number(match?.stadium?.bg?.width ?? match?.stadium?.width) || 840;
  const stadiumHeight = Number(match?.stadium?.bg?.height ?? match?.stadium?.height) || 420;
  const width = Number(entry.fieldWidth) || stadiumWidth;
  const height = Number(entry.fieldHeight) || stadiumHeight;
  const halfWidth = width / 2 || 1;
  const halfHeight = height / 2 || 1;
  const inferredTeam = normalizeTeamLabel(entry.lastTeam) || teamKey;
  const orientation = inferredTeam === 'blue' ? -1 : 1;
  const samples = toFiniteOrNull(entry.samples) || 0;
  const avgX = deriveAverage(entry.avgX, entry.sumX, samples);
  const avgY = deriveAverage(entry.avgY, entry.sumY, samples);
  const normalizedDepth = Number.isFinite(avgX) ? clampNumber((avgX / halfWidth) * orientation, -2, 2) : null;
  const lateralOrientation = inferredTeam === 'blue' ? -1 : 1;
  const normalizedLateral = Number.isFinite(avgY)
    ? clampNumber((avgY / halfHeight) * lateralOrientation, -1.5, 1.5)
    : null;
  let widthShare = deriveSpanRatio(entry.spanWidthRatio, entry.minX, entry.maxX, width);
  let heightShare = deriveSpanRatio(entry.spanHeightRatio, entry.minY, entry.maxY, height);
  let cornerShare = toFiniteOrNull(entry.cornerShare);
  const heatmapShares = deriveHeatmapShares(entry, orientation, width, height);
  if (heatmapShares) {
    if (widthShare === null) widthShare = heatmapShares.wideShare;
    if (cornerShare === null) cornerShare = heatmapShares.cornerShare;
  }
  if (cornerShare !== null) cornerShare = clampNumber(cornerShare, 0, 1);
  if (heightShare === null) {
    heightShare = deriveSpanRatio(null, entry.minY, entry.maxY, height);
  }
  return {
    positionDepth: normalizedDepth,
    positionLateral: normalizedLateral,
    positionWideShare: widthShare,
    positionCornerShare: cornerShare,
    normalizedDepth,
    normalizedLateral,
    widthShare,
    heightShare,
    samples
  };
}

function buildPositionLookup(positionAnalytics) {
  const map = new Map();
  if (Array.isArray(positionAnalytics)) {
    positionAnalytics.forEach((entry) => {
      const name = resolvePlayerName(entry?.name ?? entry?.player ?? entry?.nick);
      const key = canonicalPlayerKey(name);
      if (key) map.set(key, entry);
    });
    return map;
  }
  if (positionAnalytics && typeof positionAnalytics === 'object') {
    Object.entries(positionAnalytics).forEach(([name, entry]) => {
      const key = canonicalPlayerKey(name);
      if (key) map.set(key, entry);
    });
  }
  return map;
}

function buildFallbackPositionAnalytics(match, teamLookup) {
  const map = new Map();
  if (!match) return map;
  const stadiumWidth = Number(match?.stadium?.bg?.width ?? match?.stadium?.width) || 0;
  const stadiumHeight = Number(match?.stadium?.bg?.height ?? match?.stadium?.height) || 0;
  const width = stadiumWidth > 0 ? stadiumWidth : 840;
  const height = stadiumHeight > 0 ? stadiumHeight : 420;
  const halfWidth = width / 2 || 1;
  const halfHeight = height / 2 || 1;
  const rows = POSITION_HEATMAP_ROWS;
  const cols = POSITION_HEATMAP_COLS;
  const events = Array.isArray(match?.touches) && match.touches.length
    ? match.touches
    : (Array.isArray(match?.kicks) ? match.kicks : []);
  if (!events.length) return map;

  const ensureEntry = (rawName) => {
    const name = resolvePlayerName(rawName);
    const key = canonicalPlayerKey(name);
    if (!key) return { entry: null, key: null };
    if (!map.has(key)) {
      const baseHeatmap = Array.from({ length: rows }, () => Array(cols).fill(0));
      map.set(key, {
        name,
        samples: 0,
        sumX: 0,
        sumY: 0,
        minX: null,
        maxX: null,
        minY: null,
        maxY: null,
        heatmap: baseHeatmap,
        samplesByTeam: { red: 0, blue: 0, spec: 0 },
        lastTeam: teamLookup.get(key) || null,
        fieldWidth: width,
        fieldHeight: height
      });
    }
    return { entry: map.get(key), key };
  };

  events.forEach((event) => {
    if (!event) return;
    const { entry, key } = ensureEntry(event.player || event.nick || event.name);
    if (!entry || !key) return;
    const x = Number(event.x);
    const y = Number(event.y);
    if (!Number.isFinite(x) || !Number.isFinite(y)) return;
    entry.samples += 1;
    entry.sumX += x;
    entry.sumY += y;
    entry.minX = entry.minX === null ? x : Math.min(entry.minX, x);
    entry.maxX = entry.maxX === null ? x : Math.max(entry.maxX, x);
    entry.minY = entry.minY === null ? y : Math.min(entry.minY, y);
    entry.maxY = entry.maxY === null ? y : Math.max(entry.maxY, y);
    const eventTeam = normalizeTeamLabel(event.team || event.teamKey || event.playerTeam) || teamLookup.get(key) || null;
    if (eventTeam === 'red') entry.samplesByTeam.red += 1;
    else if (eventTeam === 'blue') entry.samplesByTeam.blue += 1;
    else entry.samplesByTeam.spec += 1;
    if (eventTeam) entry.lastTeam = eventTeam;
    const normalizedX = Math.max(0, Math.min(0.9999, (x + halfWidth) / (width || (halfWidth * 2))));
    const normalizedY = Math.max(0, Math.min(0.9999, (y + halfHeight) / (height || (halfHeight * 2))));
    const col = Math.max(0, Math.min(cols - 1, Math.floor(normalizedX * cols)));
    const row = Math.max(0, Math.min(rows - 1, Math.floor(normalizedY * rows)));
    entry.heatmap[row][col] += 1;
  });

  Array.from(map.entries()).forEach(([key, entry]) => {
    if (!entry.samples) {
      map.delete(key);
    } else {
      if (entry.minX === null) entry.minX = 0;
      if (entry.maxX === null) entry.maxX = 0;
      if (entry.minY === null) entry.minY = 0;
      if (entry.maxY === null) entry.maxY = 0;
    }
  });

  return map;
}

function buildPositionLookupWithFallback(match, teamLookup) {
  const directLookup = buildPositionLookup(match?.positionAnalytics);
  if (directLookup.size) return directLookup;
  return buildFallbackPositionAnalytics(match, teamLookup);
}

function computeSavedByFromShots(shots) {
  const map = new Map();
  (Array.isArray(shots) ? shots : []).forEach((shot) => {
    const keeper = extractSavedBy(shot);
    if (!keeper) return;
    const name = resolvePlayerName(keeper);
    const canon = canonicalPlayerKey(name);
    if (!canon) return;
    map.set(name, (map.get(name) || 0) + 1);
  });
  return map;
}

function computePlayerMetricsForUpload(match) {
  const metricsByCanonical = new Map();
  const minutes = Number(match?.minutes) && Number(match.minutes) > 0 ? Number(match.minutes) : 0;

  const redTeamNames = Array.isArray(match?.redTeam) ? match.redTeam : [];
  const blueTeamNames = Array.isArray(match?.blueTeam) ? match.blueTeam : [];

  const passAttemptsMap = summarizePasses(match?.passes);
  const directionalPasses = summarizeDirectionalPasses(match?.passes);
  const kicksMap = summarizeKicks(match?.kicks);
  const pressuredTouches = new Map();
  (Array.isArray(match?.kicks) ? match.kicks : []).forEach((kick) => {
    if (!kick || !kick.pressured) return;
    const name = resolvePlayerName(kick.player);
    const key = canonicalPlayerKey(name);
    if (!key) return;
    pressuredTouches.set(key, (pressuredTouches.get(key) || 0) + 1);
  });

  const savedByFromShots = computeSavedByFromShots(match?.shots);
  const savesMap = summarizeSaves(match?.saves, savedByFromShots);
  const duelsMap = summarizeDuels(match?.duels);
  const reboundsMap = summarizeRebounds(match?.rebounds);
  const clearancesMap = summarizeClearances(match?.clearances);
  const clearanceRecoveriesMap = summarizeClearanceRecoveries(match?.clearanceRecoveries);
  const interceptionsMap = summarizeSimpleList(match?.interceptions);

  const advancedStats = buildAdvancedPlayerStats(match) || {};
  const advancedMap = advancedStats.advanced instanceof Map ? advancedStats.advanced : new Map();

  const teamLookup = new Map();
  redTeamNames.forEach((name) => {
    const key = canonicalPlayerKey(resolvePlayerName(name));
    if (key) teamLookup.set(key, 'red');
  });
  blueTeamNames.forEach((name) => {
    const key = canonicalPlayerKey(resolvePlayerName(name));
    if (key) teamLookup.set(key, 'blue');
  });

  const ensureMetrics = (name) => {
    const display = resolvePlayerName(name);
    const key = canonicalPlayerKey(display);
    if (!key) return null;
    if (!metricsByCanonical.has(key)) {
      const teamKey = teamLookup.get(key) || null;
      const entry = createBaseMetrics(teamKey);
      metricsByCanonical.set(key, entry);
    }
    return metricsByCanonical.get(key);
  };

  (Array.isArray(match?.player) ? match.player : []).forEach((player) => {
    if (!player || typeof player !== 'object') return;
    const key = canonicalPlayerKey(player.nick || player.name || player.player);
    const team = normalizeTeamLabel(player.team);
    if (key && team) teamLookup.set(key, team);
    if (key) {
      const ensured = ensureMetrics(player.nick || player.name || player.player);
      if (ensured && team) ensured.teamKey = team;
      if (ensured && typeof player.playedTicks === 'number') {
        ensured.playedTicks = player.playedTicks;
      }
    }
  });

  const positionLookup = buildPositionLookupWithFallback(match, teamLookup);

  (Array.isArray(match?.goals) ? match.goals : []).forEach((goal) => {
    const scorer = ensureMetrics(goal?.scorer ?? goal?.player);
    if (scorer) scorer.goals += 1;
    const assist = ensureMetrics(goal?.assist?.player ?? goal?.assist);
    if (assist) assist.assists += 1;
  });

  const shotOptions = {
    stadium: match?.stadium || null,
    redTeam: redTeamNames,
    blueTeam: blueTeamNames
  };

  (Array.isArray(match?.shots) ? match.shots : []).forEach((shot, index) => {
    const shooter = ensureMetrics(shot?.player ?? shot?.scorer);
    if (!shooter) return;
    shooter.shotsTotal += 1;
    const onTarget = isShotOnTarget(shot);
    if (onTarget) shooter.shotsOnTarget += 1;

    let shotXg = extractShotXg(shot);
    if (!Number.isFinite(shotXg) || shotXg <= 0) {
      shotXg = estimateShotXg(shot, shotOptions);
    }
    if (!Number.isFinite(shotXg) || shotXg < 0) shotXg = 0;

    shooter.xg += shotXg;
    if (onTarget) shooter.xgOnTarget += shotXg;

    if (shot && typeof shot === 'object') {
      const updated = { ...shot };
      updated.xg = shotXg;
      const baseMetrics = updated.metrics && typeof updated.metrics === 'object' ? updated.metrics : {};
      updated.metrics = { ...baseMetrics, xg: shotXg };
      match.shots[index] = updated;
    }
  });

  passAttemptsMap.forEach((count, name) => {
    const entry = ensureMetrics(name);
    if (entry) entry.passAttempts += count;
  });

  directionalPasses.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry) return;
    entry.passesForward = value.forward || 0;
    entry.passesLateral = value.lateral || 0;
    entry.passesBackward = value.backward || 0;
    const completed = (value.forward || 0) + (value.lateral || 0) + (value.backward || 0);
    if (completed > entry.passesCompleted) entry.passesCompleted = completed;
  });

  kicksMap.forEach((count, name) => {
    const entry = ensureMetrics(name);
    if (entry) entry.touches += count;
  });

  pressuredTouches.forEach((count, key) => {
    const entry = metricsByCanonical.get(key);
    if (entry) entry.pressuredTouches += count;
  });

  savesMap.forEach((count, name) => {
    const entry = ensureMetrics(name);
    if (entry) entry.saves = Math.max(entry.saves, count);
  });

  duelsMap.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry) return;
    entry.duelWins += value.wins || 0;
    entry.duelLosses += value.losses || 0;
  });

  reboundsMap.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry || !value) return;
    entry.rebounds += Number(value.total) || 0;
  });

  clearancesMap.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry || !value) return;
    entry.clearances += Number(value.total) || 0;
  });

  clearanceRecoveriesMap.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry || !value) return;
    entry.clearanceRecoveries += Number(value.total) || 0;
  });

  interceptionsMap.forEach((count, name) => {
    const entry = ensureMetrics(name);
    if (entry) entry.interceptions += count;
  });

  advancedMap.forEach((value, name) => {
    const entry = ensureMetrics(name);
    if (!entry) return;
    entry.progressivePasses += Number(value.progressivePasses) || 0;
    entry.progressiveDistance += Number(value.progressiveDistance) || 0;
    entry.finalThirdEntries += Number(value.finalThirdEntries) || 0;
    entry.keyPasses += Number(value.keyPasses) || 0;
    if (!entry.passesForward && value.forwardPasses) entry.passesForward = Number(value.forwardPasses) || 0;
    if (!entry.passesBackward && value.backwardPasses) entry.passesBackward = Number(value.backwardPasses) || 0;
    if (!entry.passesLateral && value.lateralPasses) entry.passesLateral = Number(value.lateralPasses) || 0;
    entry.recoveries += Number(value.recoveries) || 0;
    entry.finalThirdRecoveries += Number(value.finalThirdRecoveries) || 0;
    entry.counterRuns += Number(value.counterRuns) || 0;
    entry.sweeperActions += Number(value.sweeperActions) || 0;
    entry.xgPrevented += Number(value.xgPrevented) || 0;
    entry.goalsConceded += Number(value.goalsConceded) || 0;
    entry.possessionTouches += Number(value.possessionTouches) || 0;
    entry.forcedTurnovers += Number(value.forcedTurnovers) || 0;
    entry.turnoversCommitted += Number(value.turnoversCommitted) || 0;
    entry.turnoverTouches = (entry.turnoverTouches || 0) + (Number(value.turnoverTouches) || 0);
    entry.dangerousTurnovers = (entry.dangerousTurnovers || 0) + (Number(value.dangerousTurnovers) || 0);
    if (!entry.pressuredTouches && Number.isFinite(value.pressuredPossessionTouches)) {
      entry.pressuredTouches = Number(value.pressuredPossessionTouches) || 0;
    }
  });

  metricsByCanonical.forEach((entry, key) => {
    const teamKey = teamLookup.get(key) || entry.teamKey || null;
    entry.teamKey = teamKey;

    const positionEntry = positionLookup.get(key);
    const snapshot = buildPositionSnapshot(positionEntry, teamKey, match) || null;
    if (snapshot) {
      entry.positionDepth = snapshot.positionDepth;
      entry.positionLateral = snapshot.positionLateral;
      entry.positionWideShare = snapshot.positionWideShare;
      entry.positionCornerShare = snapshot.positionCornerShare;
      entry.normalizedDepth = snapshot.normalizedDepth;
      entry.normalizedLateral = snapshot.normalizedLateral;
      entry.widthShare = snapshot.widthShare;
      entry.heightShare = snapshot.heightShare;
      entry.samples = snapshot.samples;
    }

    entry.shotsOffTarget = Math.max(0, entry.shotsTotal - entry.shotsOnTarget);
    const turnoverTouches = Number(entry.turnoverTouches) || 0;
    const dangerousTouches = Number(entry.dangerousTurnovers) || 0;
    const baselineAttempts = entry.passesCompleted + turnoverTouches + dangerousTouches;
    if (baselineAttempts > entry.passAttempts) entry.passAttempts = baselineAttempts;
    if (entry.passAttempts === 0 && entry.passesForward + entry.passesLateral + entry.passesBackward > 0) {
      entry.passAttempts = entry.passesForward + entry.passesLateral + entry.passesBackward;
    }
    if (entry.passesCompleted === 0 && entry.passesForward + entry.passesLateral + entry.passesBackward > 0) {
      entry.passesCompleted = entry.passesForward + entry.passesLateral + entry.passesBackward;
    }
    if (entry.passesCompleted === 0 && entry.passAttempts > 0) {
      entry.passesCompleted = entry.passAttempts;
    }
    if (entry.touches === 0 && entry.possessionTouches > 0) {
      entry.touches = entry.possessionTouches;
    }
    if (entry.pressuredTouches > entry.touches) {
      entry.pressuredTouches = entry.touches;
    }
    entry.passCompletionRate = entry.passAttempts > 0
      ? clampNumber(entry.passesCompleted / entry.passAttempts, 0, 1)
      : 0;
    const passTempoDenominator = entry.passesCompleted || entry.passAttempts;
    entry.passesPerMinute = minutes > 0 ? (passTempoDenominator / minutes) : 0;
    entry.touchesPerMinute = minutes > 0 ? (entry.touches / minutes) : 0;
    entry.pressureRelief = entry.touches > 0
      ? clampNumber(1 - (entry.pressuredTouches / entry.touches), 0, 1)
      : 0;
    entry.duelTotal = entry.duelWins + entry.duelLosses;
    entry.duelWinRate = entry.duelTotal > 0
      ? clampNumber(entry.duelWins / entry.duelTotal, 0, 1)
      : 0;
  });

  return metricsByCanonical;
}

function sanitizeMatchForUpload(match, index) {
  if (!match || typeof match !== 'object') return {};

  const normalizeName = (entry) => {
    if (entry === undefined || entry === null) return null;
    const str = typeof entry === 'string' ? entry : (entry.nick || entry.name || entry.player || entry.display || '');
    if (typeof str !== 'string') return null;
    const trimmed = str.trim();
    return trimmed || null;
  };

  const ratingSummary = computePlayerRatingsForMatch(match);
  const ratingsByNick = ratingSummary && typeof ratingSummary === 'object' && ratingSummary.ratingsByNick
    ? ratingSummary.ratingsByNick
    : {};
  const toNullableNumber = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  };

  const blueTeamRaw = cloneArrayValue(match.blueTeam);
  const redTeamRaw = cloneArrayValue(match.redTeam);
  let blueTeam = blueTeamRaw
    .map(normalizeName)
    .filter((name, idx, arr) => !!name && arr.indexOf(name) === idx);
  let redTeam = redTeamRaw
    .map(normalizeName)
    .filter((name, idx, arr) => !!name && arr.indexOf(name) === idx);
  if (!redTeam.length || !blueTeam.length) {
    const inferred = inferTeamsFromMatch(match);
    if (inferred.red.length && !redTeam.length) redTeam = inferred.red;
    if (inferred.blue.length && !blueTeam.length) blueTeam = inferred.blue;
  }
  const blueCanonical = new Set(blueTeam.map((name) => name.toLowerCase()));
  const redCanonical = new Set(redTeam.map((name) => name.toLowerCase()));
  let stadiumClone = deepCloneValue(match.stadium, null);
  if (stadiumClone && typeof stadiumClone !== 'object') stadiumClone = null;

  const ensureMinutes = (min, ticks) => {
    if (Number.isFinite(Number(min))) return Number(min);
    const ticksNum = toFiniteNumberOr(ticks, 0);
    return ticksNum > 0 ? ticksNum / 3600 : 0;
  };

  const minutes = ensureMinutes(match.minutes, match.gameTicks);
  const sanitized = {
    matchId: toFiniteNumberOr(match.matchId, index ?? 0),
    matchIndex: index ?? toFiniteNumberOr(match.matchIndex, 0),
    scoreBlue: toFiniteNumberOr(match.scoreBlue, 0),
    scoreRed: toFiniteNumberOr(match.scoreRed, 0),
    spaceMode: Boolean(match.spaceMode),
    realSoccerMode: Boolean(match.realSoccerMode),
    stadiumName: (match.stadium && match.stadium.name) || match.stadiumName || (stadiumClone && stadiumClone.name) || 'Unknown',
    stadium: stadiumClone,
    redTeamName: match.redTeamName || 'RED',
    blueTeamName: match.blueTeamName || 'BLUE',
    isFflSevenAside: isFflSevenAsideMatch({ ...match, stadium: stadiumClone || match.stadium, minutes }),
    blueTeam,
    redTeam,
    goals: cloneArrayValue(match.goals),
    player: cloneArrayValue(match.player),
    players: cloneArrayValue(match.players),
    shots: cloneArrayValue(match.shots),
    passes: cloneArrayValue(match.passes),
    touches: cloneArrayValue(match.touches),
    saves: cloneArrayValue(match.saves),
    duels: cloneArrayValue(match.duels),
    rebounds: cloneArrayValue(match.rebounds),
    reboundRecoveries: cloneArrayValue(match.reboundRecoveries),
    clearances: cloneArrayValue(match.clearances),
    clearanceRecoveries: cloneArrayValue(match.clearanceRecoveries),
    gkOccupancy: cloneArrayValue(match.gkOccupancy),
    kicks: cloneArrayValue(match.kicks),
    bumps: cloneArrayValue(match.bumps),
    interceptions: cloneArrayValue(match.interceptions),
    possRed: toFiniteNumberOr(match.possRed, 0),
    possBlue: toFiniteNumberOr(match.possBlue, 0),
    thirds: cloneArrayValue(match.thirds),
    thirdTotals: cloneArrayValue(match.thirdTotals),
    gameTicks: toFiniteNumberOr(match.gameTicks, 0),
    minutes,
    matchMeta: deepCloneValue(match.matchMeta, undefined),
    positionAnalytics: deepCloneValue(match.positionAnalytics, null)
  };

  if (!Array.isArray(sanitized.player) && sanitized.players.length) {
    sanitized.player = sanitized.players;
  }
  if (!Array.isArray(sanitized.players) && sanitized.player.length) {
    sanitized.players = sanitized.player;
  }
  if (!sanitized.thirds.length && sanitized.thirdTotals.length) {
    sanitized.thirds = sanitized.thirdTotals;
  }

  if (Array.isArray(sanitized.player)) {
    sanitized.player = sanitized.player.map((entry) => {
      if (!entry || typeof entry !== 'object') return entry;
      const clone = { ...entry };
      const nick = normalizeName(clone.nick || clone.player || clone.name || clone.display);
      if (nick) {
        if (redCanonical.has(nick.toLowerCase())) clone.team = 'red';
        else if (blueCanonical.has(nick.toLowerCase())) clone.team = 'blue';
        else clone.team = clone.team || null;
        clone.nick = nick;
      }
      return clone;
    });
  }

  sanitized.blueTeam = Array.from(blueTeam);
  sanitized.redTeam = Array.from(redTeam);

  const metricsByCanonical = computePlayerMetricsForUpload(sanitized);

  const existingCanonicals = new Set();
  if (Array.isArray(sanitized.player)) {
    sanitized.player.forEach((p) => {
      const key = canonicalPlayerKey(p.nick || p.name || p.player);
      if (key) existingCanonicals.add(key);
    });
  }

  metricsByCanonical.forEach((metrics, key) => {
    if (!existingCanonicals.has(key)) {
      const newPlayer = {
        nick: metrics.name || key,
        team: metrics.teamKey || null
      };
      if (!Array.isArray(sanitized.player)) sanitized.player = [];
      sanitized.player.push(newPlayer);
    }
  });

  if (Array.isArray(sanitized.player)) {
    sanitized.player = sanitized.player.map((entry) => {
      if (!entry || typeof entry !== 'object') return entry;
      const key = canonicalPlayerKey(entry.nick || entry.name || entry.player);
      const metrics = key && metricsByCanonical.has(key)
        ? metricsByCanonical.get(key)
        : createBaseMetrics(normalizeTeamLabel(entry.team));
      const normalizedTeam = normalizeTeamLabel(entry.team);
      if (normalizedTeam && metrics.teamKey !== normalizedTeam) {
        metrics.teamKey = normalizedTeam;
      }
      const ratingEntry = key && ratingsByNick[key] ? ratingsByNick[key] : null;
      const ratingModel = ratingEntry ? {
        modelVersion: ratingEntry.modelVersion,
        breakdown: ratingEntry.breakdown,
        provisional: ratingEntry.provisional,
        rating: toNullableNumber(ratingEntry.rating),
        ratingRaw: toNullableNumber(ratingEntry.ratingRaw),
        ratingZ: toNullableNumber(ratingEntry.ratingZ),
        baseline: toNullableNumber(ratingEntry.baseline),
        modelPrediction: toNullableNumber(ratingEntry.modelPrediction),
        advancedScore: toNullableNumber(ratingEntry.advancedScore),
        offenseLeverage: toNullableNumber(ratingEntry.offenseLeverage),
        defenseLeverage: toNullableNumber(ratingEntry.defenseLeverage),
        chainShare: toNullableNumber(ratingEntry.chainShare),
        counterShare: toNullableNumber(ratingEntry.counterShare)
      } : null;
      let ratingTeam = null;
      if (ratingEntry) {
        ratingTeam = normalizeTeamLabel(ratingEntry.team);
        if (ratingTeam && !metrics.teamKey) metrics.teamKey = ratingTeam;
        if (typeof ratingEntry.role === 'string' && ratingEntry.role && !metrics.role) {
          metrics.role = ratingEntry.role;
        }
        if (typeof ratingEntry.position === 'string' && ratingEntry.position && !metrics.position) {
          metrics.position = ratingEntry.position;
        }
      }
      const cleaned = { ...entry };
      if (!cleaned.team && (metrics.teamKey || ratingTeam)) {
        cleaned.team = metrics.teamKey || ratingTeam;
      }
      delete cleaned.goals;
      delete cleaned.assists;
      delete cleaned.kicks;
      delete cleaned.attemptedPasses;
      delete cleaned.xg;
      delete cleaned.keyPasses; // legacy duplicates can appear on some exports
      delete cleaned.progressivePasses;
      delete cleaned.progressiveDistance;
      delete cleaned.finalThirdEntries;
      delete cleaned.touches;
      delete cleaned.shotsOnTarget;
      delete cleaned.shotsOffTarget;
      if (metrics && Object.prototype.hasOwnProperty.call(metrics, 'turnoversCommitted')) {
        delete metrics.turnoversCommitted;
      }
      return { ...cleaned, metrics, rating: ratingModel };
    });
    sanitized.players = Array.isArray(sanitized.players) ? sanitized.player : sanitized.player;
  }

  const aggregateTeamShots = () => {
    const shotTotals = {
      red: { onTarget: 0, offTarget: 0, total: 0 },
      blue: { onTarget: 0, offTarget: 0, total: 0 }
    };
    metricsByCanonical.forEach((metrics) => {
      if (!metrics || (metrics.teamKey !== 'red' && metrics.teamKey !== 'blue')) return;
      const teamKey = metrics.teamKey;
      const shotsTotal = Number(metrics.shotsTotal) || 0;
      const shotsOnTarget = Number(metrics.shotsOnTarget) || 0;
      const shotsOffTarget = Number.isFinite(Number(metrics.shotsOffTarget))
        ? Number(metrics.shotsOffTarget)
        : Math.max(0, shotsTotal - shotsOnTarget);
      shotTotals[teamKey].onTarget += shotsOnTarget;
      shotTotals[teamKey].offTarget += shotsOffTarget;
      shotTotals[teamKey].total += shotsTotal || (shotsOnTarget + shotsOffTarget);
    });

    const toCount = (value, fallback = 0) => {
      const num = Number(value);
      if (Number.isFinite(num) && num > 0) return Math.round(Math.max(0, num));
      const fb = Number(fallback);
      return Number.isFinite(fb) ? Math.round(Math.max(0, fb)) : 0;
    };

    const existing = {
      red: {
        onTarget: sanitized.shotsRed ?? match?.shotsRed,
        offTarget: sanitized.shotsOffTargetRed ?? match?.shotsOffTargetRed
      },
      blue: {
        onTarget: sanitized.shotsBlue ?? match?.shotsBlue,
        offTarget: sanitized.shotsOffTargetBlue ?? match?.shotsOffTargetBlue
      }
    };

    const redOnTarget = toCount(shotTotals.red.onTarget, existing.red.onTarget);
    const redOffTarget = toCount(shotTotals.red.offTarget, existing.red.offTarget);
    const blueOnTarget = toCount(shotTotals.blue.onTarget, existing.blue.onTarget);
    const blueOffTarget = toCount(shotTotals.blue.offTarget, existing.blue.offTarget);

    const redTotal = redOnTarget + redOffTarget;
    const blueTotal = blueOnTarget + blueOffTarget;

    sanitized.shotsRed = redOnTarget;
    sanitized.shotsBlue = blueOnTarget;
    sanitized.shotsOffTargetRed = redOffTarget;
    sanitized.shotsOffTargetBlue = blueOffTarget;
    sanitized.shotsTotalRed = redTotal;
    sanitized.shotsTotalBlue = blueTotal;
    sanitized.teamShotSummary = {
      red: { onTarget: redOnTarget, offTarget: redOffTarget, total: redTotal },
      blue: { onTarget: blueOnTarget, offTarget: blueOffTarget, total: blueTotal }
    };
  };

  aggregateTeamShots();

  const clearSpectatorAssignments = () => {
    const spectatorCanonicals = new Set();
    const markIfSpectator = (entry) => {
      if (!entry || typeof entry !== 'object') return;
      const metrics = entry.metrics && typeof entry.metrics === 'object' ? entry.metrics : null;
      if (!metrics) return;
      const rosterTeam = normalizeTeamLabel(entry.team);
      const metricsTeam = normalizeTeamLabel(metrics.teamKey);
      if (!rosterTeam && !metricsTeam) return;
      const activityValues = [
        metrics.samples,
        metrics.touches,
        metrics.possessionTouches,
        metrics.passAttempts,
        metrics.passesCompleted,
        metrics.pressuredTouches,
        metrics.goals,
        metrics.assists,
        metrics.shotsTotal,
        metrics.shotsOnTarget,
        metrics.shotsOffTarget,
        metrics.saves,
        metrics.clearances,
        metrics.clearanceRecoveries,
        metrics.rebounds,
        metrics.recoveries,
        metrics.duelWins,
        metrics.duelLosses,
        metrics.counterRuns,
        metrics.xg,
        metrics.xgOnTarget,
        metrics.xgPrevented,
        metrics.turnoverTouches,
        metrics.sweeperActions
      ];
      const hasActivity = activityValues.some((value) => Number(value) > 0);
      if (hasActivity) return;
      const canonical = canonicalPlayerKey(entry.nick || entry.name || entry.player);
      if (rosterTeam) entry.team = null;
      if (metricsTeam) metrics.teamKey = null;
      if (metrics.role) metrics.role = null;
      if (metrics.position) metrics.position = null;
      if (entry.rating) entry.rating = null;
      if (canonical) spectatorCanonicals.add(canonical);
    };
    if (Array.isArray(sanitized.player)) sanitized.player.forEach(markIfSpectator);
    if (Array.isArray(sanitized.players) && sanitized.players !== sanitized.player) {
      sanitized.players.forEach(markIfSpectator);
    }
    if (spectatorCanonicals.size) {
      sanitized.redTeam = sanitized.redTeam.filter((name) => {
        const canonical = canonicalPlayerKey(name);
        return !canonical || !spectatorCanonicals.has(canonical);
      });
      sanitized.blueTeam = sanitized.blueTeam.filter((name) => {
        const canonical = canonicalPlayerKey(name);
        return !canonical || !spectatorCanonicals.has(canonical);
      });
    }
  };

  clearSpectatorAssignments();

  sanitized.playerRatings = {
    modelVersion: ratingSummary.modelVersion,
    red: Array.isArray(ratingSummary?.red)
      ? ratingSummary.red.map((entry) => ({
          nick: entry.nick || null,
          rating: toNullableNumber(entry.rating)
        }))
      : [],
    blue: Array.isArray(ratingSummary?.blue)
      ? ratingSummary.blue.map((entry) => ({
          nick: entry.nick || null,
          rating: toNullableNumber(entry.rating)
        }))
      : [],
    mvpNick: ratingSummary?.mvpNick || null
  };

  return sanitized;
}

function Home() {
  const receiveMessageRef = useRef(null);
  const rawSocketUrl = (() => {
    if (typeof window !== 'undefined' && window.location.origin) {
      const configured = process.env.REACT_APP_SOCKET_URL;
      if (!configured || configured.includes('maghrebsmp.fun')) {
        return window.location.origin.replace(/^http/, 'ws') + '/ws/';
      }
      return configured;
    }
    return process.env.REACT_APP_SOCKET_URL || '';
  })();
  const socketUrl = rawSocketUrl && rawSocketUrl.endsWith('/ws') ? rawSocketUrl + '/' : rawSocketUrl;
  // Examples:
  // REACT_APP_SOCKET_URL=ws://haxball-replay-analyzer.com:8080/
  // REACT_APP_SOCKET_URL=ws://localhost:8080/
  const STATIC_OPTIONS = {
    onOpen: () => {
      // console.log('Connected with WebSocket')
      if (!paramsChecked) {
        checkParams();
        setParamsChecked(true)
      }
      // Flush any pending upload once socket opens
      try {
        if (pendingUpload) {
          const { buffer, name, lastModified } = pendingUpload
          // send binary (chunked if needed)
          if (buffer.byteLength > 50_000) {
            let x = new Uint8Array(buffer);
            let arr = Array.from(x);
            while (arr.length > 0) {
              const part = arr.splice(0, 50_000)
              const ab = new ArrayBuffer(part.length);
              const view = new Uint8Array(ab);
              for (let i = 0; i < part.length; i++) view[i] = part[i]
              sendMessage(ab)
            }
          } else {
            sendMessage(buffer)
          }
          sendMessage(JSON.stringify({ header: 'replaySent' }))
          setLastModified(lastModified);
          setReplayName(name);
          pendingUpload = null;
        }
      } catch (_) { pendingUpload = null; }
    },
    onClose: (e) => {
      console.log('Connection closed', e.reason);
    },
    onMessage: (event) => receiveMessageRef.current?.(event),
    shouldReconnect: (closeEvent) => true,
    reconnectAttempts: 10,
    reconnectInterval: 3000
  }
  const { sendMessage, readyState } = useWebSocket(socketUrl, STATIC_OPTIONS);

  const dispatch = useDispatch();
  const mainMode = useSelector((state) => state.mainMode.value);
  const version = useSelector((state) => state.mainMode.version);
  const userDidUpload = useSelector(state => state.mainMode.userUploaded);
  const [replayId, setReplayId] = useState(null);
  const [replayName, setReplayName] = useState(null);
  const [replayLastModified, setLastModified] = useState(null);
  const [paramsChecked, setParamsChecked] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);
  const filterPlayer = useSelector(state => state.replays.filters.player)
  const filterTeam = useSelector(state => state.replays.filters.team)
  const filterReplay = useSelector(state => state.replays.filters.replay)
  const filterGoal = useSelector(state => state.replays.filters.goal)
  const filterStadium = useSelector(state => state.replays.filters.stadium)
  const filterSpaceMode = useSelector(state => state.replays.filters.spaceMode)
  const filterRealSoccer = useSelector(state => state.replays.filters.realSoccer)
  const searchText = useSelector(state => state.replays.filters.searchText)
  const periodState = useSelector(state => state.replays.filters.period)
  const replaysType = useSelector(state => state.replays.type);
  const replays = useSelector(state => state.replays.replays);
  const replaysQty = replays.replays?.length;
  const startDate = useSelector(state => state.replays.filters.startDate)
  const endDate = useSelector(state => state.replays.filters.endDate)

  const [clipAvailable, setClipAvailable] = useState(false);
  const [clipStatus, setClipStatus] = useState('idle');
  const [clipDuration, setClipDuration] = useState(0);
  const [clipError, setClipError] = useState(null);
  const [clipOutput, setClipOutput] = useState(null);
  const clipRecorderRef = useRef(null);
  const clipTickerRef = useRef(null);
  const clipStartRef = useRef(null);
  const clipLastDurationRef = useRef(0);
  const clipActionRef = useRef('save');
  const clipUrlRef = useRef(null);
  const clipUploadAbortRef = useRef(null);
  const clipBlobRef = useRef(null);
  const clipFpsRef = useRef(30);
  const lastReplaysQueryRef = useRef({});
  const fallbackResultsRef = useRef(false);
  const archiveRequestRef = useRef(null);

  useEffect(() => {
    if (mainMode !== 'replays') archiveRequestRef.current?.abort();
  }, [mainMode]);

  useEffect(() => () => archiveRequestRef.current?.abort(), []);

  const shouldUseFullFallback = useCallback((criteria = {}) => {
    const text = typeof criteria.searchText === 'string' ? criteria.searchText.trim() : '';
    if (text.length > 0) return true;
    if (criteria.filterSpaceMode || criteria.filterRealSoccer) return true;
    if (criteria.startDate || criteria.endDate) return true;
    return false;
  }, []);

  const fetchFallbackReplays = useCallback(async ({ type, limit = 50, maxPages = 200, signal } = {}) => {
    const base = getRecordingServerBase();
    if (!base) return null;
    const normalizedBase = base.replace(/\/$/, '');
    const normalizedType = encodeURIComponent(type || 'latest');
    const combined = {
      replays: [],
      matches: [],
      players: [],
      goals: [],
      teams: []
    };
    let offset = 0;
    let page = 0;
    let hasMore = false;

    while (page < maxPages) {
      const url = `${normalizedBase}/api/replays?type=${normalizedType}&limit=${limit}&offset=${offset}`;
      let res;
      try {
        res = await fetch(url, { cache: 'no-store', signal });
      } catch (_) {
        break;
      }
      if (!res || !res.ok) {
        break;
      }
      let data;
      try {
        data = await res.json();
      } catch (_) {
        break;
      }
      const payload = data && data.replays;
      if (!payload || !Array.isArray(payload.replays)) {
        break;
      }

      const appendArray = (key) => {
        const source = Array.isArray(payload[key]) ? payload[key] : [];
        if (!Array.isArray(combined[key])) combined[key] = [];
        combined[key] = combined[key].concat(source);
      };

      appendArray('replays');
      appendArray('matches');
      appendArray('players');
      appendArray('goals');
      appendArray('teams');

      Object.keys(payload).forEach((key) => {
        if (['replays', 'matches', 'players', 'goals', 'teams'].includes(key)) return;
        const value = payload[key];
        if (Array.isArray(value)) {
          if (!Array.isArray(combined[key])) combined[key] = [];
          combined[key] = combined[key].concat(value);
        } else if (combined[key] === undefined) {
          combined[key] = value;
        }
      });

      const fetched = payload.replays.length;
      offset += fetched;
      page += 1;

      if (fetched < limit) {
        hasMore = false;
        break;
      }
      if (page >= maxPages) {
        hasMore = true;
        break;
      }
    }

    combined.hasMore = hasMore;
    return combined;
  }, []);

  const filterReplaysPayload = useCallback((payload, criteria = {}) => {
    if (!payload || !Array.isArray(payload.replays)) return payload;

    const toLower = (value) => typeof value === 'string' ? value.toLowerCase() : '';
    const ensureArray = (value) => Array.isArray(value) ? value : [];

    const parseDateValue = (value) => {
      if (!value) return null;
      if (value instanceof Date) {
        const ms = value.getTime();
        return Number.isNaN(ms) ? null : ms;
      }
      if (typeof value === 'number' && Number.isFinite(value)) return value;
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;
        const normalized = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
        const date = new Date(normalized);
        const ms = date.getTime();
        if (!Number.isNaN(ms)) return ms;
      }
      return null;
    };

    const parseBoundaryDate = (value, endOfDay = false) => {
      const ms = parseDateValue(value);
      if (ms === null) return null;
      if (!endOfDay) return ms;
      const dt = new Date(ms);
      dt.setHours(23, 59, 59, 999);
      return dt.getTime();
    };

    const normalizeFlag = (val, key) => {
      if (typeof val === 'boolean') return val;
      if (typeof val === 'number') return val !== 0;
      if (typeof val === 'string') {
        const lower = val.toLowerCase();
        if (['true', '1', 'yes', 'y'].includes(lower)) return true;
        if (['false', '0', 'no', 'n'].includes(lower)) return false;
        if (key === 'spaceMode') return lower.includes('space');
        if (key === 'realSoccerMode') return lower.includes('real') || lower.includes('soccer');
      }
      return null;
    };

    const extractModeFlag = (replayEntry, matchesList, key) => {
      const checkObject = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        const candidates = [
          obj[key],
          obj[key.charAt(0).toUpperCase() + key.slice(1)],
          obj[key.toLowerCase()],
          obj[key.toUpperCase()],
          obj[key.replace(/Mode$/i, '')],
          obj[`${key.replace(/Mode$/i, '')}Mode`],
          obj[`${key.replace(/Mode$/i, '')}mode`],
          obj.mode
        ];
        for (const candidate of candidates) {
          const normalized = normalizeFlag(candidate, key);
          if (normalized !== null) return normalized;
        }
        return null;
      };
      const direct = checkObject(replayEntry);
      if (typeof direct === 'boolean') return direct;
      for (const m of matchesList) {
        const derived = checkObject(m);
        if (typeof derived === 'boolean') return derived;
      }
      return false;
    };

    const includesText = (values, query) => {
      for (const value of values) {
        if (typeof value === 'string' && toLower(value).includes(query)) {
          return true;
        }
      }
      return false;
    };

    const replaysArray = ensureArray(payload.replays);
    const matchesArray = ensureArray(payload.matches);
    const playersArray = ensureArray(payload.players);
    const goalsArray = ensureArray(payload.goals);
    const teamsArray = ensureArray(payload.teams);

    const flags = {
      replay: Boolean(criteria.filterReplay),
      team: Boolean(criteria.filterTeam),
      player: Boolean(criteria.filterPlayer),
      goal: Boolean(criteria.filterGoal),
      stadium: Boolean(criteria.filterStadium)
    };
    const anySearchFlag = flags.replay || flags.team || flags.player || flags.goal || flags.stadium;
    const query = (criteria.searchText || '').toString().trim().toLowerCase();
    const hasQuery = query.length > 0;

    const startBoundary = parseBoundaryDate(criteria.startDate, false);
    const endBoundary = parseBoundaryDate(criteria.endDate, true);

    const computePeriodCutoff = (period, type) => {
      if (!period || (type && type !== 'mostViewed')) return null;
      const lower = period.toString().toLowerCase();
      if (lower === 'week') return Date.now() - (7 * 24 * 60 * 60 * 1000);
      if (lower === 'month') return Date.now() - (30 * 24 * 60 * 60 * 1000);
      return null;
    };
    const periodCutoff = computePeriodCutoff(criteria.period, criteria.replaysType);

    const indices = [];
    for (let i = 0; i < replaysArray.length; i++) {
      const replayEntry = replaysArray[i] || {};
      const matchList = ensureArray(matchesArray[i]);
      const playerList = ensureArray(playersArray[i]);
      const goalList = ensureArray(goalsArray[i]);
      const teamList = ensureArray(teamsArray[i]);

      const sentDate = replayEntry.SentDate || replayEntry.sentDate || replayEntry.CreatedDate || replayEntry.createdDate;
      const replayTimestamp = parseDateValue(sentDate);

      if (startBoundary !== null && (replayTimestamp === null || replayTimestamp < startBoundary)) continue;
      if (endBoundary !== null && (replayTimestamp === null || replayTimestamp > endBoundary)) continue;
      if (periodCutoff !== null && (replayTimestamp === null || replayTimestamp < periodCutoff)) continue;

      if (criteria.filterSpaceMode && !extractModeFlag(replayEntry, matchList, 'spaceMode')) continue;
      if (criteria.filterRealSoccer && !extractModeFlag(replayEntry, matchList, 'realSoccerMode')) continue;

      if (hasQuery) {
        const allowAllTargets = !anySearchFlag;
        let matched = false;
        const tryValues = (values) => {
          if (!matched && includesText(values, query)) {
            matched = true;
          }
        };
        if (flags.replay || allowAllTargets) {
          tryValues([
            replayEntry.ReplayName,
            replayEntry.ReplayId,
            replayEntry.replayName,
            replayEntry.replayId,
            replayEntry.FileName,
            replayEntry.fileName
          ]);
        }
        if (!matched && (flags.team || allowAllTargets)) {
          tryValues(teamList.map(team => team?.TeamName || team?.teamName || team?.Name));
        }
        if (!matched && (flags.player || allowAllTargets)) {
          tryValues(playerList.map(player => player?.Nick || player?.nick || player?.PlayerName || player?.name));
        }
        if (!matched && (flags.goal || allowAllTargets)) {
          const goalNames = goalList.map(goal => {
            if (!goal) return null;
            if (typeof goal === 'string') return goal;
            if (goal.Nick || goal.nick) return goal.Nick || goal.nick;
            if (goal.scorer) {
              if (typeof goal.scorer === 'string') return goal.scorer;
              if (typeof goal.scorer === 'object') return goal.scorer.Nick || goal.scorer.nick || goal.scorer.player;
            }
            return null;
          });
          tryValues(goalNames);
        }
        if (!matched && (flags.stadium || allowAllTargets)) {
          tryValues(matchList.map(match => match?.StadiumName || match?.stadiumName || match?.stadium));
        }
        if (!matched) continue;
      }

      indices.push(i);
    }

    if (indices.length === replaysArray.length) return payload;

    const filterArrayByIndices = (arr) => {
      if (!Array.isArray(arr)) return arr;
      const result = [];
      for (const idx of indices) {
        if (idx < arr.length) result.push(arr[idx]);
      }
      return result;
    };

    const filtered = { ...payload };
    filtered.replays = filterArrayByIndices(replaysArray);
    filtered.matches = filterArrayByIndices(matchesArray);
    filtered.players = filterArrayByIndices(playersArray);
    filtered.goals = filterArrayByIndices(goalsArray);
    filtered.teams = filterArrayByIndices(teamsArray);
    if (typeof payload.hasMore === 'boolean') {
      filtered.hasMore = payload.hasMore;
    }

    for (const key of Object.keys(payload)) {
      if (['replays', 'matches', 'players', 'goals', 'teams'].includes(key)) continue;
      const value = payload[key];
      if (Array.isArray(value) && value.length === replaysArray.length) {
        filtered[key] = filterArrayByIndices(value);
      }
    }

    return filtered;
  }, []);

  const resetClipOutput = useCallback(() => {
    setClipOutput(prev => {
      const prevUrl = clipUrlRef.current || prev?.localUrl;
      if (prevUrl) {
        try { URL.revokeObjectURL(prevUrl) } catch (_) {}
        if (clipUrlRef.current === prevUrl) clipUrlRef.current = null;
      }
      return null;
    })
  }, [])

  const stopClipTimer = useCallback(() => {
    if (clipTickerRef.current) {
      try { clearInterval(clipTickerRef.current) } catch (_) {}
      clipTickerRef.current = null;
    }
    if (clipStartRef.current) {
      const seconds = Math.max(0, Math.round((Date.now() - clipStartRef.current) / 1000));
      clipLastDurationRef.current = seconds;
      setClipDuration(seconds);
      clipStartRef.current = null;
    }
  }, [])

  const startClipTimer = useCallback(() => {
    if (clipTickerRef.current) {
      try { clearInterval(clipTickerRef.current) } catch (_) {}
    }
    clipStartRef.current = Date.now();
    clipLastDurationRef.current = 0;
    setClipDuration(0);
    clipTickerRef.current = window.setInterval(() => {
      if (!clipStartRef.current) return;
      const seconds = Math.max(0, Math.round((Date.now() - clipStartRef.current) / 1000));
      clipLastDurationRef.current = seconds;
      setClipDuration(seconds);
    }, 500);
  }, [])

  const getReplayCanvas = useCallback(() => {
    if (typeof document === 'undefined') return null;
    const selectors = [
      '#game-state-view .canvas canvas',
      '#game-state-view canvas',
      '[data-hook="canvas"] canvas',
      '#game-canvas canvas',
      '.game-canvas canvas'
    ];
    for (const selector of selectors) {
      const found = document.querySelector(selector);
      if (found) return found;
    }
    const canvases = Array.from(document.querySelectorAll('canvas'));
    if (!canvases.length) return null;
    let best = null;
    let bestScore = -Infinity;
    for (const node of canvases) {
      let rectWidth = 0;
      let rectHeight = 0;
      try {
        const rect = node.getBoundingClientRect();
        rectWidth = rect?.width || 0;
        rectHeight = rect?.height || 0;
      } catch (_) {}
      const attrWidth = Number(node.width || node.getAttribute('width') || 0) || 0;
      const attrHeight = Number(node.height || node.getAttribute('height') || 0) || 0;
      let bufferWidth = 0;
      let bufferHeight = 0;
      try {
        const gl = node.getContext && (node.getContext('webgl2') || node.getContext('webgl'));
        if (gl && gl.drawingBufferWidth && gl.drawingBufferHeight) {
          bufferWidth = gl.drawingBufferWidth;
          bufferHeight = gl.drawingBufferHeight;
        } else if (gl && gl.canvas) {
          bufferWidth = gl.canvas.width || bufferWidth;
          bufferHeight = gl.canvas.height || bufferHeight;
        }
      } catch (_) {}
      const logicalWidth = Math.max(attrWidth, bufferWidth, rectWidth);
      const logicalHeight = Math.max(attrHeight, bufferHeight, rectHeight);
      const score = Math.max(logicalWidth, logicalHeight);
      if (score > bestScore) {
        bestScore = score;
        best = node;
      }
    }
    return best || canvases[0] || null;
  }, [])

  const formatClipTime = useCallback((seconds) => {
    const total = Math.max(0, Number(seconds) || 0);
    const mins = Math.floor(total / 60);
    const secs = String(total % 60).padStart(2, '0');
    return `${mins}:${secs}`;
  }, [])

  const computeClipFilename = useCallback((ext = 'webm', createdAt = null) => {
    const baseSource = (replayName || (typeof window !== 'undefined' ? window.__replayName : null) || replayId || 'replay').toString();
    const sanitized = baseSource.trim().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_-]/g, '').replace(/-+/g, '-').slice(0, 60) || 'clip';
    const stamp = new Date(createdAt || Date.now()).toISOString().replace(/[:.]/g, '-');
    const cleanExt = (ext || 'webm').replace(/^\.+/, '');
    return `${sanitized}-clip-${stamp}.${cleanExt || 'webm'}`;
  }, [replayName, replayId])

  const clipFilename = useMemo(() => {
    if (!clipOutput) return '';
    if (clipOutput.filename) return clipOutput.filename;
    return computeClipFilename(clipOutput.ext, clipOutput.createdAt);
  }, [clipOutput, computeClipFilename])

  const clipDurationLabel = useMemo(() => {
    const seconds = clipStatus === 'ready' ? (clipOutput?.recordedSeconds ?? clipDuration) : clipStatus === 'uploading' ? (clipOutput?.recordedSeconds ?? clipDuration) : clipDuration;
    return formatClipTime(seconds);
  }, [clipDuration, clipOutput, clipStatus, formatClipTime])

  const clipStatusLabel = useMemo(() => {
    if (clipStatus === 'recording') return `Recording ${clipDurationLabel}`;
    if (clipStatus === 'processing') return 'Finishing…';
    if (clipStatus === 'uploading') return `Uploading ${clipDurationLabel}`;
    if (clipStatus === 'ready') return `Ready ${clipDurationLabel}`;
    return 'Idle';
  }, [clipDurationLabel, clipStatus])

  const clipPortalSelector = '[data-hook="clipcontrols"]';
  const [clipPortalNode, setClipPortalNode] = useState(() => (typeof document === 'undefined' ? null : document.querySelector(clipPortalSelector)));

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const observer = new MutationObserver(() => {
      const node = document.querySelector(clipPortalSelector);
      setClipPortalNode((prev) => (prev === node ? prev : node));
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const ensureReplayPlaying = useCallback(() => {
    try {
      const playIcon = document.querySelector('[data-hook="playicon"]');
      const playButton = document.querySelector('[data-hook="play"]');
      if (!playIcon || !playButton) return false;
      const state = (playIcon.textContent || '').trim();
      if (state !== '⏸') {
        playButton.click();
        return true;
      }
    } catch (_) {}
    return false;
  }, []);

  const ensureReplayPaused = useCallback(() => {
    try {
      const playIcon = document.querySelector('[data-hook="playicon"]');
      const playButton = document.querySelector('[data-hook="play"]');
      if (!playIcon || !playButton) return false;
      const state = (playIcon.textContent || '').trim();
      if (state === '⏸') {
        playButton.click();
        return true;
      }
    } catch (_) {}
    return false;
  }, []);

  const uploadClipBlob = useCallback((blob, outputMeta = {}) => {
    if (!blob) {
      setClipStatus('ready');
      setClipError('Clip data unavailable');
      return;
    }
    const base = getRecordingServerBase();
    if (!base) {
      setClipStatus('ready');
      setClipError('Recording server unavailable. Clip saved locally only.');
      return;
    }
    const controller = new AbortController();
    clipUploadAbortRef.current = controller;
    const createdAt = outputMeta.createdAt || Date.now();
    const ext = (outputMeta.ext || (blob.type && blob.type.includes('mp4') ? 'mp4' : 'webm')).replace(/^\.+/, '') || 'webm';
    const filename = outputMeta.filename || computeClipFilename(ext, createdAt);
    setClipOutput(prev => prev ? { ...prev, createdAt, ext, filename } : { createdAt, ext, filename, shareUrl: null, serverShareUrl: null });
    setClipStatus('uploading');
    const normalizedBase = base.replace(/\/$/, '');
    const target = `${normalizedBase}/save-clip?filename=${encodeURIComponent(filename)}`;
    const contentType = normalizeMimeType(outputMeta.mime || blob.type || 'video/webm');
    fetch(target, {
      method: 'POST',
      body: blob,
      headers: { 'Content-Type': contentType },
      signal: controller.signal
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data?.ok === false) {
          const message = data?.error || `Upload failed (${res.status})`;
          throw new Error(message);
        }
        const selectUrl = (...candidates) => {
          for (const candidate of candidates) {
            if (typeof candidate === 'string' && candidate.length) {
              return candidate;
            }
          }
          return '';
        };
        const resolveUrl = (value) => {
          if (!value) return '';
          return (/^https?:/i.test(value) || value.startsWith('//'))
            ? value
            : normalizedBase + (value.startsWith('/') ? value : '/' + value);
        };

        const shareRel = selectUrl(data.shareUrl, data.shareRelativeUrl);
        const shareUrl = resolveUrl(shareRel);

        const rel = selectUrl(data.mp4Url, data.url, data.webmUrl, data.originalWebmUrl);
        const publicUrl = resolveUrl(rel);

        const webmRelCandidate = selectUrl(
          data.webmUrl,
          data.originalWebmUrl,
          rel && rel.toLowerCase().endsWith('.webm') ? rel : ''
        );
        const webmUrl = webmRelCandidate
          ? resolveUrl(webmRelCandidate)
          : (publicUrl && publicUrl.toLowerCase().endsWith('.webm') ? publicUrl : '');

        const mp4Rel = selectUrl(data.mp4Url, rel && rel.toLowerCase().endsWith('.mp4') ? rel : '');
        const mp4Url = mp4Rel
          ? resolveUrl(mp4Rel)
          : (publicUrl && publicUrl.toLowerCase().endsWith('.mp4') ? publicUrl : '');

        setClipOutput(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            serverUrl: mp4Url || publicUrl || shareUrl || webmUrl || prev.serverUrl || '',
            serverRelativeUrl: rel,
            serverMp4Url: mp4Url || null,
            serverWebmUrl: webmUrl || null,
            serverShareUrl: shareUrl || null,
            shareUrl: shareUrl || prev.shareUrl || null,
            response: data
          };
        });
        setClipError(null);
        setClipStatus('ready');
      })
      .catch((err) => {
        if (controller.signal.aborted || err?.name === 'AbortError') {
          return;
        }
        setClipStatus('ready');
        setClipError(err?.message || 'Upload failed');
      })
      .finally(() => {
        if (clipUploadAbortRef.current === controller) {
          clipUploadAbortRef.current = null;
        }
      });
  }, [computeClipFilename])

  const processRecordedClip = useCallback(async ({ blob, mime, ext }) => {
    stopClipTimer();
    clipRecorderRef.current = null;
    const recordedSeconds = clipLastDurationRef.current;
    setClipDuration(recordedSeconds);
    const shouldDiscard = clipActionRef.current === 'discard';
    clipActionRef.current = 'save';
    if (shouldDiscard) {
      resetClipOutput();
      setClipStatus('idle');
      setClipError(null);
      return;
    }
    if (!blob || !blob.size) {
      setClipError('Clip recording failed: empty output');
      setClipStatus('idle');
      resetClipOutput();
      return;
    }
    let ensuredBlob = blob;
    let effectiveMime = normalizeMimeType(mime || blob.type || 'video/webm');
    try {
      const buffer = await blob.arrayBuffer();
      if (buffer && buffer.byteLength) {
        ensuredBlob = new Blob([buffer], { type: effectiveMime });
        effectiveMime = normalizeMimeType(ensuredBlob.type || effectiveMime);
      }
    } catch (err) {
      console.warn('clip finalize failed', err);
    }

    let extension = (ext || (effectiveMime && effectiveMime.includes('webm') ? 'webm' : '')).replace(/^\.+/, '') || 'webm';
    let localUrl = null;
    try {
      localUrl = URL.createObjectURL(ensuredBlob);
      clipUrlRef.current = localUrl;
    } catch (err) {
      console.warn('clip preview url failed', err);
      localUrl = null;
      clipUrlRef.current = null;
    }
    clipBlobRef.current = ensuredBlob;
    const createdAt = Date.now();
    const filename = computeClipFilename(extension, createdAt);
    setClipOutput({
      localUrl,
      ext: extension,
      recordedSeconds,
      createdAt,
      filename,
      mime: effectiveMime,
      serverShareUrl: null,
      shareUrl: null
    });
    setClipError(null);
    uploadClipBlob(ensuredBlob, {
      localUrl,
      ext: extension,
      recordedSeconds,
      createdAt,
      filename,
      mime: effectiveMime
    });
  }, [computeClipFilename, resetClipOutput, setClipError, setClipStatus, stopClipTimer, uploadClipBlob])

  const handleStartClip = useCallback(() => {
    if (clipStatus === 'recording') return;
    if (clipUploadAbortRef.current) {
      try { clipUploadAbortRef.current.abort(); } catch (_) {}
      clipUploadAbortRef.current = null;
    }
    clipBlobRef.current = null;
    resetClipOutput();
    setClipError(null);
    const canvas = getReplayCanvas();
    if (!canvas) {
      setClipError('Replay canvas not ready');
      try { openModal('Clip recording is unavailable until the replay is visible.', 'darkred', 4) } catch (_) {}
      return;
    }
    ensureReplayPlaying();
    try {
      clipFpsRef.current = 30;
      const recorder = startCanvasRecording({
        canvas,
        fps: clipFpsRef.current,
        preferMp4: false,
        onStop: ({ blob, mime, ext }) => {
          processRecordedClip({ blob, mime, ext });
        }
      });
      clipRecorderRef.current = recorder;
      clipActionRef.current = 'save';
      startClipTimer();
      setClipStatus('recording');
    } catch (err) {
      clipRecorderRef.current = null;
      stopClipTimer();
      setClipStatus('idle');
      setClipError(err?.message || 'Recording not supported');
      try { openModal('Clip recording is not supported in this browser.', 'darkred', 5) } catch (_) {}
    }
  }, [clipStatus, ensureReplayPlaying, getReplayCanvas, processRecordedClip, resetClipOutput, startClipTimer, stopClipTimer])

  const handleStopClip = useCallback(() => {
    if (clipStatus !== 'recording' || !clipRecorderRef.current) return;
    clipActionRef.current = 'save';
    stopClipTimer();
    setClipStatus('processing');
    try {
      clipRecorderRef.current.stop();
    } catch (err) {
      clipRecorderRef.current = null;
      setClipStatus('idle');
      setClipError(err?.message || 'Unable to stop recording');
    }
    ensureReplayPaused();
  }, [clipStatus, ensureReplayPaused, stopClipTimer])

  const handleCancelClip = useCallback(() => {
    if (clipStatus === 'recording' && clipRecorderRef.current) {
      clipActionRef.current = 'discard';
      stopClipTimer();
      try { clipRecorderRef.current.stop() } catch (_) {}
      clipRecorderRef.current = null;
      return;
    }
    if (clipStatus === 'uploading') {
      if (clipUploadAbortRef.current) {
        try { clipUploadAbortRef.current.abort(); } catch (_) {}
        clipUploadAbortRef.current = null;
      }
      setClipStatus('ready');
      setClipError('Upload cancelled');
      return;
    }
    if (clipUploadAbortRef.current) {
      try { clipUploadAbortRef.current.abort(); } catch (_) {}
      clipUploadAbortRef.current = null;
    }
    clipBlobRef.current = null;
    resetClipOutput();
    setClipStatus('idle');
    setClipDuration(0);
    setClipError(null);
  }, [clipStatus, resetClipOutput, stopClipTimer])

  const handleNewClip = useCallback(() => {
    if (clipUploadAbortRef.current) {
      try { clipUploadAbortRef.current.abort(); } catch (_) {}
      clipUploadAbortRef.current = null;
    }
    clipBlobRef.current = null;
    resetClipOutput();
    setClipStatus('idle');
    setClipDuration(0);
    setClipError(null);
  }, [resetClipOutput])

  const handleDownloadClip = useCallback(() => {
    const url = clipOutput?.serverMp4Url || clipOutput?.serverUrl || clipOutput?.localUrl || clipUrlRef.current;
    if (!url) return;
    const link = window.document.createElement('a');
    link.href = url;
    const serverName = clipOutput?.response?.filename || clipOutput?.response?.originalFilename || '';
    const fallbackName = clipOutput?.serverMp4Url
      ? (clipFilename ? clipFilename.replace(/\.webm$/i, '.mp4') : 'replay-clip.mp4')
      : (clipFilename || 'replay-clip.webm');
    link.download = serverName || fallbackName;
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  }, [clipFilename, clipOutput])

  const handleUploadClip = useCallback(() => {
    if (!clipBlobRef.current) {
      setClipError('Clip data not available for upload');
      return;
    }
    setClipError(null);
    uploadClipBlob(clipBlobRef.current, clipOutput || {});
  }, [clipOutput, uploadClipBlob])

  const handleCopyClipLink = useCallback(async () => {
    const url = clipOutput?.serverMp4Url || clipOutput?.serverUrl;
    if (!url) return;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const temp = window.document.createElement('input');
        temp.value = url;
        window.document.body.appendChild(temp);
        temp.select();
        window.document.execCommand('copy');
        window.document.body.removeChild(temp);
      }
      setClipError(null);
      try { openModal('Clip link copied to clipboard.', 'green', 3) } catch (_) {}
    } catch (err) {
      setClipError(err?.message || 'Unable to copy link');
    }
  }, [clipOutput])

  const handleOpenClipLink = useCallback(() => {
    const url = clipOutput?.serverMp4Url || clipOutput?.serverUrl;
    if (!url) return;
    window.open(url, '_blank', 'noopener');
  }, [clipOutput])

  useEffect(() => {
    return () => {
      if (clipRecorderRef.current) {
        try { clipRecorderRef.current.stop() } catch (_) {}
        clipRecorderRef.current = null;
      }
      if (clipTickerRef.current) {
        try { clearInterval(clipTickerRef.current) } catch (_) {}
        clipTickerRef.current = null;
      }
      if (clipUrlRef.current) {
        try { URL.revokeObjectURL(clipUrlRef.current) } catch (_) {}
        clipUrlRef.current = null;
      }
      if (clipUploadAbortRef.current) {
        try { clipUploadAbortRef.current.abort(); } catch (_) {}
        clipUploadAbortRef.current = null;
      }
      clipBlobRef.current = null;
    }
  }, [])

  useEffect(() => {
    if (!clipAvailable) {
      if (clipRecorderRef.current) {
        clipActionRef.current = 'discard';
        try { clipRecorderRef.current.stop() } catch (_) {}
        clipRecorderRef.current = null;
      }
      if (clipUploadAbortRef.current) {
        try { clipUploadAbortRef.current.abort(); } catch (_) {}
        clipUploadAbortRef.current = null;
      }
      clipBlobRef.current = null;
      stopClipTimer();
      resetClipOutput();
      setClipStatus('idle');
      setClipDuration(0);
      setClipError(null);
    }
  }, [clipAvailable, resetClipOutput, stopClipTimer])

  const clipControlsElement = useMemo(() => {
    if (!clipAvailable) return null;
    return (
      <div className="clip-controls">
        <span className="clip-label">Clip</span>
        <div className="clip-button-grid">
          {clipStatus === 'recording' ? (
            <>
              <button className="clip-button-wide" onClick={handleStopClip}>Stop ({clipDurationLabel})</button>
              <button className="clip-button-wide" onClick={handleCancelClip}>Cancel</button>
            </>
          ) : clipStatus === 'processing' ? (
            <>
              <button className="clip-button-wide" disabled>Finishing…</button>
              <button className="clip-button-wide" onClick={handleCancelClip}>Cancel</button>
            </>
          ) : clipStatus === 'uploading' ? (
            <>
              <button className="clip-button-wide" disabled>Uploading…</button>
              <button className="clip-button-wide" onClick={handleCancelClip}>Cancel Upload</button>
            </>
          ) : clipStatus === 'ready' ? (
            <>
              {clipOutput?.serverUrl ? (
                <div className="clip-button-row">
                  <button onClick={handleCopyClipLink}>Copy Link</button>
                  <button onClick={handleOpenClipLink}>Open Link</button>
                </div>
              ) : (
                <button className="clip-button-wide" onClick={handleUploadClip} disabled={!clipBlobRef.current}>Upload to Server</button>
              )}
              <div className="clip-button-row">
                <button onClick={handleDownloadClip} title={clipFilename || 'Download clip'} disabled={!clipOutput?.serverUrl && !clipOutput?.localUrl}>Download</button>
                <button onClick={handleNewClip}>New Clip</button>
              </div>
            </>
          ) : (
            <button className="clip-button-wide" onClick={handleStartClip}>Start Clip</button>
          )}
        </div>
        <span className="clip-status">{clipStatusLabel}</span>
        {clipError && <span className="clip-error">{clipError}</span>}
      </div>
    );
  }, [
    clipAvailable,
    clipStatus,
    clipDurationLabel,
    clipOutput,
    clipFilename,
    clipError,
    clipStatusLabel,
    handleStopClip,
    handleCancelClip,
    handleUploadClip,
    handleDownloadClip,
    handleNewClip,
    handleCopyClipLink,
    handleOpenClipLink,
    handleStartClip
  ]);

  const clipControls = useMemo(() => {
    if (!clipControlsElement) return null;
    if (clipPortalNode) return createPortal(clipControlsElement, clipPortalNode);
    return mainMode === 'home' ? clipControlsElement : null;
  }, [clipControlsElement, clipPortalNode, mainMode]);

  function receiveMessage(m) {
    let x;
    try { x = JSON.parse(m.data); } catch (_) { return; }
    // console.log(x);
    if (x.header === 'insertedReplayId') {
      const addURL = "?replayId=" + x.id;
      window.history.replaceState(null, '', addURL);
      setReplayId(x.id);
      replayIdToSend = x.id;
      // If stats already computed, send them now with this id
      if (!waitingForStats && queryMessage) {
        try { sendMessage(JSON.stringify({ ...queryMessage, replayId: replayIdToSend })) } catch (_) {}
        try { postStatsHTTP(replayIdToSend, queryMessage) } catch (_) {}
      }
    } else if (x.header === 'replayPart') {
      replayData = replayData.concat(x.rec.data);
    } else if (x.header === 'replaySent') {
      if (startedPlayback) {
        // Already started via HTTP fallback; ignore duplicate finish
        return;
      }
      // If server already provides replayId here, set it immediately
      if (x.replayId) {
        const addURL = "?replayId=" + x.replayId;
        try {
          window.history.replaceState(null, '', addURL);
        } catch (_) {}
        try { setReplayId(x.replayId); } catch (_) {}
        replayIdToSend = x.replayId;
        // If stats already computed, send them now with this id
        if (!waitingForStats && queryMessage) {
          try { sendMessage(JSON.stringify({ ...queryMessage, replayId: replayIdToSend })) } catch (_) {}
          try { postStatsHTTP(replayIdToSend, queryMessage) } catch (_) {}
        }
      }
      if (x?.connectHalves) dispatch(setConnectHalves(true))
      else dispatch(setConnectHalves(false))

      const tnames = Array.isArray(x.teamNames) ? x.teamNames : [];
      for (let i = 0; i < tnames.length; i++) {
        const j = Math.floor(i / 2);
        if (i % 2 === 0) {
          dispatch(setRedTeamName({ mtc: j, name: tnames[i].TeamName }))
        } else dispatch(setBlueTeamName({ mtc: j, name: tnames[i].TeamName }))
      }

      const y = replayData;
      const buffer = new ArrayBuffer(y.length);
      const uint8View = new Uint8Array(buffer);
      for (let i = 0; i < y.length; i++) {
        uint8View[i] = y[i]; // zapisywanie danych z tablicy do bufora ArrayBuffer
      }
      const newBuffer = uint8View.buffer; // konwersja widoku Uint8Array na ArrayBuffer
      // Keep userUploaded true until stats are prepared and sent
      replayData = [];

      setClipAvailable(false);

      $(function () {

        $('#downloading-screen').animate({
          left: '-150%',
        }, { duration: 700, easing: 'swing', queue: false, complete: function () { $("#downloading-screen").css('left', '100%') } });

        $('#loading-screen').animate({
          left: '35vw',
        }, { duration: 700, easing: 'swing', queue: false, complete: function () {
          // Start the replay
          if (startedPlayback) return;
          startedPlayback = true;
          startedReplayId = replayId || null;
          setClipAvailable(true);
          if (replayId) {
            try { incrementViews(replayId); } catch (_) { }
            try { dispatch(incrementReplayViews(replayId)); } catch (_) { }
          }
          try {
            replayFromSite(newBuffer);
          } catch (err) {
            console.error('Error starting replay:', err);
            $('#loading-screen').stop().css('left', '150%');
            openModal('Failed to start replay: ' + (err.message || 'unknown error'), 'darkgoldenrod', 5);
          }
          try {
            window.__replayName = replayName || ('replay-' + new Date().toISOString().replace(/[:.]/g, '-'))
          } catch (e) { }
        } });

      })
    } else if (x.header === 'alreadyUploaded') {
      const addURL = "?replayId=" + x.replayId;
      window.history.replaceState(null, '', addURL);
      setReplayId(x.replayId);
      openModal('This recording has already been uploaded. Redirected to this replay.', 'darkgoldenrod', 5)
    } else if (x.header === 'top10 stats') {
      for (let idx = 0; idx < x.replays?.replays?.length || 0; idx++) {
        if (x.replays.replays[idx].ConnectedHalves) {
          connectHalves(x.replays, idx)
        }
      }
      if (fallbackResultsRef.current) {
        dispatch(setLoadingMore(false));
        return;
      }
      fallbackResultsRef.current = false;
      const criteria = lastReplaysQueryRef.current || {};
      const filtered = filterReplaysPayload(x.replays, criteria);
      dispatch(setReplaysLoaded(true));
      dispatch(setReplays(filtered));
      dispatch(setMainMode('replays'));
    } else if (x.header === 'invalidLink') {
      $(function () {
        $('#downloading-screen').stop().animate({ left: '100%' }, { duration: 400 });
        $('.roomlist-view').stop().animate({ left: '35vw' }, { duration: 400 });
      });
      openModal('Invalid link - replay with given ID doesn\'t exist', 'darkgoldenrod', 4);
    } else if (x.header === 'next10 stats') {
      if (mainMode !== 'replays' || !Array.isArray(x.replays?.replays)) return;
      for (let idx = 0; idx < x.replays.replays.length; idx++) {
        if (x.replays.replays[idx].ConnectedHalves) {
          connectHalves(x.replays, idx)
        }
      }
      if (fallbackResultsRef.current) {
        dispatch(setLoadingMore(false));
        return;
      }
      fallbackResultsRef.current = false;
      const criteria = lastReplaysQueryRef.current || {};
      const filtered = filterReplaysPayload(x.replays, criteria);
      if (filtered.replays && filtered.replays.length > 0) dispatch(addMoreReplays(filtered));
      dispatch(setLoadingMore(false))
    }
  }
  receiveMessageRef.current = receiveMessage;

  function connectHalves(replays, i) {
    if (!Array.isArray(replays.matches?.[i]) || replays.matches[i].length < 2 || !replays.teams?.[i]?.[0]) return;
    const firstMatchId = replays.matches[i][0].MatchId;
    const firstTeamId = replays.teams[i][0].TeamId;
    const teamIds = [firstTeamId, firstTeamId + 1, firstTeamId + 2, firstTeamId + 3]
    for (let goal of replays.goals[i]) {
      goal.MatchId = firstMatchId;
    }
    replays.matches[i][0].RedScore += replays.matches[i][1].BlueScore;
    replays.matches[i][0].BlueScore += replays.matches[i][1].RedScore;
    replays.matches[i].splice(1, 1);
    var tempPlayers = [];
    for (let player of replays.players[i]) {
      if (!tempPlayers.includes(player.Nick)) {
        if (player.TeamId === teamIds[2]) player.TeamId = teamIds[1];
        if (player.TeamId === teamIds[3]) player.TeamId = teamIds[0];
      }
      tempPlayers.push(player.Nick)
    }
  }

  // Background recording removed; no MP4 Loading/Download button injected

  const checkParams = useCallback(async () => {
    const qs = new URLSearchParams(window.location.search);
    const id = qs.get('replayId');
    if (id && startedReplayId === id) return;
    startedPlayback = false;
    startedReplayId = null;
    setClipAvailable(false);
    stopClipTimer();
    resetClipOutput();
    setClipStatus('idle');
    setClipDuration(0);
    setClipError(null);
    if (id) {
      const toSend = { header: 'select', id };
      try { setReplayId(id) } catch (e) {}
      // If socket not yet open, the message will be sent onOpen via our handler above
      try { sendMessage(JSON.stringify(toSend)) } catch (_) {}
      $(function () {
        $('.roomlist-view').animate({ left: '-150%' }, { duration: 700, easing: 'swing', queue: false });
        $('#downloading-screen').animate({ left: '35vw' }, { duration: 700, easing: 'swing', queue: false });
      })
      // HTTP fallback: try same-origin /replays/<id>.hbr2
      ;(async () => {
        try {
          const base = getRecordingServerBase();
          if (base && !startedPlayback) {
            const url = base.replace(/\/$/, '') + '/replays/' + encodeURIComponent(id) + '.hbr2'
            const res = await fetch(url, { cache: 'no-store' })
            if (res.ok) {
              const buf = await res.arrayBuffer()
              if (!startedPlayback) {
                $(function () {
                  $('#downloading-screen').animate({ left: '-150%' }, { duration: 700, easing: 'swing', queue: false, complete: function () { $("#downloading-screen").css('left', '100%') } })
                  $('#loading-screen').animate({ left: '35vw' }, { duration: 700, easing: 'swing', queue: false, complete: function () {
                    if (startedPlayback) return;
                    startedPlayback = true;
                    startedReplayId = id;
                    setClipAvailable(true);
                    try { incrementViews(id) } catch(_){};
                    try { dispatch(incrementReplayViews(id)); } catch (_) { }
                    try {
                      replayFromSite(buf);
                    } catch (err) {
                      console.error('Error starting replay fallback:', err);
                      $('#loading-screen').stop().css('left', '150%');
                      openModal('Failed to load replay.', 'darkgoldenrod', 5);
                    }
                  } })
                })
              }
            }
          }
        } catch (_) { /* ignore */ }
      })();

      // Safety timeout: if neither WS nor HTTP fallback started playback within 5.5s, exit downloading screen
      setTimeout(() => {
        if (!startedPlayback) {
          $(function () {
            $('#downloading-screen').stop().animate({ left: '100%' }, { duration: 400 });
            $('.roomlist-view').stop().animate({ left: '35vw' }, { duration: 400 });
          });
          openModal('Replay file could not be downloaded or was not found.', 'darkgoldenrod', 5);
        }
      }, 5500);
      return;
    }

    // Only replayId is supported
  }, [dispatch, resetClipOutput, sendMessage, setClipAvailable, setClipStatus, setClipDuration, setClipError, setReplayId, stopClipTimer]);

  function showReplays(ev) {
    const target = ev?.currentTarget || ev?.target;
    const datasetType = target?.dataset?.replaysType;
    let rType = datasetType === 'latest' ? 'latest' : 'mostViewed';
    if (!datasetType && target?.textContent && target.textContent.toLowerCase().includes('latest')) {
      rType = 'latest';
    }

    dispatch(setReplaysType(rType));
    dispatch(setReplaysLoaded(false));
    dispatch(setMainMode('replays'));

    const toSend = {
      header: 'top10',
      period: periodState || 'week',
      replaysType: rType,
      searchText,
      filterPlayer,
      filterGoal,
      filterRealSoccer,
      filterReplay,
      filterSpaceMode,
      filterStadium,
      filterTeam,
      startDate,
      endDate
    };
    lastReplaysQueryRef.current = { ...toSend };
    fallbackResultsRef.current = false;

    try {
      sendMessage(JSON.stringify(toSend));
    } catch (_) {}

    const base = getRecordingServerBase();
    if (base) {
      if (shouldUseFullFallback(toSend)) {
        (async () => {
          try {
            const aggregated = await fetchFallbackReplays({ type: rType });
            if (!aggregated) return;
            const filtered = filterReplaysPayload(aggregated, toSend);
            fallbackResultsRef.current = aggregated.hasMore === false;
            dispatch(setReplays(filtered));
            dispatch(setReplaysLoaded(true));
            dispatch(setLoadingMore(false));
          } catch (_) { /* ignore */ }
        })();
      } else {
        setTimeout(async () => {
          try {
            const url = base.replace(/\/$/, '') + `/api/replays?type=${encodeURIComponent(rType)}&limit=10`;
            const res = await fetch(url, { cache: 'no-store' });
            if (res.ok) {
              const data = await res.json();
              if (data && data.replays) {
                const filtered = filterReplaysPayload(data.replays, toSend);
                dispatch(setReplays(filtered));
                dispatch(setReplaysLoaded(true));
              }
            }
          } catch (_) { /* ignore */ }
        }, 1200);
      }
    }
  }


  function showStatsExp(elStyle) {
    const { offsetLeft, offsetTop, clientWidth, clientHeight } = elStyle;
    const offsetParentTop = elStyle.offsetParent.offsetTop;
    dispatch(setDivStyle({ offsetLeft, offsetTop, offsetParentTop, clientWidth, clientHeight }));
    dispatch(setMainMode('stats'));
  }

  function setGameStatsExp(stats) {
    let statsPayload = stats;
    try {
      if (typeof structuredClone === 'function') {
        statsPayload = structuredClone(stats);
      } else {
        statsPayload = JSON.parse(JSON.stringify(stats));
      }
    } catch (_) {
      try {
        statsPayload = JSON.parse(JSON.stringify(stats));
      } catch (_) {
        statsPayload = Array.isArray(stats) ? stats.map((entry) => ({ ...entry })) : stats;
      }
    }
    dispatch(setStats(statsPayload));
    // Prepare and send stats to server only for user uploads
    if (userDidUpload) {
      const activeHeadless = headlessReplayContext;
      var message = [];
      for (var i = 0; i < stats.length; i++) {
        const match = stats[i];
        dispatch(setRedTeamName({ mtc: i, name: 'RED' }))
        dispatch(setBlueTeamName({ mtc: i, name: 'BLUE' }))
        const sanitizedMatch = sanitizeMatchForUpload(match, i);
        message.push(sanitizedMatch);
      }
      const effectiveReplayId = replayIdToSend || activeHeadless?.replayId || null;
      const effectiveReplayName = replayName || activeHeadless?.replayName || replayIdToSend || null;
      const effectiveLastModified = replayLastModified || activeHeadless?.lastModified || Date.now();
      const toSend = {
        header: 'setStats',
        stats: message,
        replayId: effectiveReplayId,
        replayName: effectiveReplayName,
        lastModified: effectiveLastModified,
      }
      queryMessage = toSend;
      waitingForStats = false;
      // Send immediately if we have a replayId already
      if (effectiveReplayId) {
        try { sendMessage(JSON.stringify({ ...queryMessage, replayId: effectiveReplayId })) } catch (_) {}
        try { postStatsHTTP(effectiveReplayId, queryMessage) } catch (_) {}
      }
      // Now mark upload flow as finished for UI permissions
      dispatch(setUserUploaded(false));
      headlessReplayContext = null;
    }
  }

  function setPlayerListExp(el) {
    const payload = Array.isArray(el) ? cloneArrayValue(el) : el;
    dispatch(setPlayerList(payload));
  }

  function setPlayerPosExp(el) {
    const payload = Array.isArray(el) ? cloneArrayValue(el) : el;
    dispatch(setPlayerPos(payload));
  }

  function dispatchClearStatsExp() {
    dispatch(clearStats());
  }

  // eslint-disable-next-line no-func-assign
  changeTeamNames = function (names, matchId) {
    const toSend = {
      header: 'changeTeamNames',
      names: names,
      matchId: matchId,
      replayId: replayId
    }
    sendMessage(JSON.stringify(toSend))
  }

  // eslint-disable-next-line no-func-assign
  loadMoreReplays = function (a) {
    if (fallbackResultsRef.current) {
      dispatch(setLoadingMore(false));
      return;
    }
    const toSend = {
      header: 'next10 filtered',
      replaysType: replaysType,
      searchText: searchText,
      filterPlayer: filterPlayer,
      filterGoal: filterGoal,
      filterRealSoccer: filterRealSoccer,
      filterReplay: filterReplay,
      filterSpaceMode: filterSpaceMode,
      filterStadium: filterStadium,
      filterTeam: filterTeam,
      period: periodState,
      alreadyLoaded: replaysQty,
      startDate: startDate,
      endDate: endDate
    }
    const criteria = { ...toSend };
    if (!criteria.replaysType) criteria.replaysType = replaysType;
    lastReplaysQueryRef.current = criteria;
    sendMessage(JSON.stringify(criteria))
  }

  // eslint-disable-next-line no-func-assign
  sendMessageExp = function (m) {
    sendMessage(JSON.stringify(m))
  }

  // eslint-disable-next-line no-func-assign
  sendSocketMessage = function (m, n, o) {
    try {
      // Also upload to public recording server for cross-device sharing
      const base = getRecordingServerBase();
      if (base) {
        const sanitize = (s) => String(s || '').replace(/[^a-zA-Z0-9._-]/g, '')
        const baseName = sanitize(n || 'replay') || 'replay'
        const stamp = new Date().toISOString().replace(/[:.]/g, '-')
        const fname = `${baseName}-${stamp}.hbr2`
        const target = base.replace(/\/$/, '') + '/save-replay?filename=' + encodeURIComponent(fname)
        fetch(target, { method: 'POST', body: m, headers: { 'Content-Type': 'application/octet-stream' } })
          .then(async (r) => {
            if (r.ok) return r.json();
            let message = `Remote upload failed (HTTP ${r.status})`;
            try {
              const payload = await r.json();
              if (payload && payload.error) message += `: ${payload.error}`;
            } catch (_) {}
            throw new Error(message);
          })
          .then(data => {
            try {
              // Prefer explicit id from HTTP API if provided
              const id = data && (data.id || (String(data.url || '').split('/').filter(Boolean).pop() || '').replace(/\.hbr2$/i, ''))
              if (id) {
                const newUrl = `${window.location.origin}${window.location.pathname}?replayId=${encodeURIComponent(id)}`
                window.history.replaceState(null, '', newUrl)
                try { setReplayId(id) } catch (_) {}
                replayIdToSend = id
                // If stats are already prepared, send now
                if (!waitingForStats && queryMessage) {
                  try { sendMessage(JSON.stringify({ ...queryMessage, replayId: id })) } catch (_) {}
                  try { postStatsHTTP(id, queryMessage) } catch (_) {}
                }
                try { openModal('Replay link ready', 'green', 3) } catch (_) {}
              } else {
                try { openModal('Uploaded. Waiting for replayId…', 'green', 3) } catch (_) {}
              }
            } catch (_) {
              try { openModal('Uploaded. Waiting for replayId…', 'green', 3) } catch (_) {}
            }
          })
          .catch((err) => {
            try { console.warn('Remote replay upload failed:', err && err.message ? err.message : err); } catch (_) {}
            try { openModal('Remote backup failed; continuing with live upload', 'darkred', 5); } catch (_) {}
          })
      }
    } catch (_) {}
    setReplayName(n);
    // If WS not open yet, queue the upload and wait for onOpen to flush
    if (readyState !== ReadyState.OPEN) {
      pendingUpload = { buffer: m, name: n, lastModified: o };
      try { openModal('Connecting to server… generating replayId shortly', 'darkgoldenrod', 4) } catch (_) {}
    } else {
      if (m.byteLength > 50_000) {
        var replayParts = [];
        var x = new Uint8Array(m);
        x = Array.from(x)
        do {
          replayParts.push(x.splice(0, 50_000))
        } while (x.length > 50_000)
        replayParts.push(x);
        for (let part of replayParts) {
          const buffer = new ArrayBuffer(part.length);
          const uint8View = new Uint8Array(buffer);
          for (let i = 0; i < part.length; i++) {
            uint8View[i] = part[i];
          }
          const newBuffer = uint8View.buffer;
          sendMessage(newBuffer)
        }
      } else {
        sendMessage(m)
      }
      sendMessage(JSON.stringify({ header: 'replaySent' }))
      setLastModified(o);
    }
  }

  // eslint-disable-next-line no-func-assign
  search4Replays = function (toSend) {
    archiveRequestRef.current?.abort();
    const controller = new AbortController();
    archiveRequestRef.current = controller;
    dispatch(setReplaysLoaded(false));
    const criteria = { ...toSend };
    if (!criteria.replaysType) criteria.replaysType = replaysType;
    lastReplaysQueryRef.current = criteria;
    fallbackResultsRef.current = false;
    try { sendMessage(JSON.stringify(criteria)) } catch (_) {}
    // HTTP fallback to clip server simple list (no filters)
    try {
      const base = getRecordingServerBase();
      if (base && (toSend.header === 'top10' || toSend.header === 'top10 filtered')) {
        if (shouldUseFullFallback(criteria)) {
          fetchFallbackReplays({ type: criteria.replaysType, signal: controller.signal })
            .then(aggregated => {
              if (!aggregated || controller.signal.aborted) return;
              const filtered = filterReplaysPayload(aggregated, criteria);
              fallbackResultsRef.current = aggregated.hasMore === false;
              dispatch(setReplays(filtered))
              dispatch(setReplaysLoaded(true))
              dispatch(setLoadingMore(false))
            })
            .catch(() => {})
        } else {
          const type = encodeURIComponent(criteria.replaysType || 'latest')
          const url = base.replace(/\/$/, '') + `/api/replays?type=${type}&limit=10`
          fetch(url, { cache: 'no-store', signal: controller.signal })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
              if (!controller.signal.aborted && data && data.replays) {
                const filtered = filterReplaysPayload(data.replays, criteria);
                dispatch(setReplays(filtered))
                dispatch(setReplaysLoaded(true))
              }
            })
            .catch(() => {})
        }
      }
    } catch (_) {}
  }

  // eslint-disable-next-line no-func-assign
  showStats = showStatsExp;
  // eslint-disable-next-line no-func-assign
  setGameStats = setGameStatsExp;
  // eslint-disable-next-line no-func-assign
  dispatchPlayerList = setPlayerListExp;
  // eslint-disable-next-line no-func-assign
  dispatchPlayerPos = setPlayerPosExp;
  // eslint-disable-next-line no-func-assign
  dispatchClearStats = dispatchClearStatsExp;
  // eslint-disable-next-line no-func-assign
  checkParamsExp = function () {
    checkParams();
  }
  // eslint-disable-next-line no-func-assign
  markClipReady = function () {
    setClipAvailable(true)
  }
  // eslint-disable-next-line no-func-assign
  clearClipReady = function () {
    setClipAvailable(false)
    if (clipUploadAbortRef.current) {
      try { clipUploadAbortRef.current.abort() } catch (_) {}
      clipUploadAbortRef.current = null
    }
    clipBlobRef.current = null
    stopClipTimer()
    resetClipOutput()
    setClipStatus('idle')
    setClipDuration(0)
    setClipError(null)
  }

  function callbackFn(e) {
    handleFile(e);
  }

  function handleChange(e) {
    if (!e?.target?.files?.length) return;
    setClipAvailable(false);
    if (clipRecorderRef.current) {
      clipActionRef.current = 'discard';
      try { clipRecorderRef.current.stop() } catch (_) {}
      clipRecorderRef.current = null;
    }
    stopClipTimer();
    resetClipOutput();
    setClipStatus('idle');
    setClipDuration(0);
    setClipError(null);

    dispatch(setUserUploaded(true));
    dispatch(setConnectHalves(false))
    dispatch(setConnectedHalves(false))
    startedPlayback = false;
    setReplayId(null);
    waitingForStats = true;

    $(function () {

      $('.roomlist-view').animate({
        left: '-150%',
      }, { duration: 700, easing: 'swing', queue: false });

      $('#loading-screen').animate({
        left: '35vw',
      }, { duration: 700, easing: 'swing', queue: false, complete: function () {
        try {
          callbackFn(e);
        } catch (err) {
          console.error('Error handling uploaded file:', err);
          $('#loading-screen').stop().css('left', '150%');
          openModal('Failed to open uploaded replay.', 'darkgoldenrod', 5);
        }
      } });

    })

  }

  const handleDragOver = (event) => {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    setIsDragActive(true);
  };

  const handleDragLeave = (event) => {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.currentTarget && event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setIsDragActive(false);
  };

  const handleDropFile = (event) => {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    setIsDragActive(false);
    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length) {
      const syntheticEvent = {
        target: { files },
        preventDefault: () => {},
        stopPropagation: () => {}
      };
      handleChange(syntheticEvent);
    }
  };


  // Ensure URL params are processed even if WebSocket fails to connect
  useEffect(() => {
    if (!paramsChecked) {
      try { checkParams(); } catch (e) {}
      setParamsChecked(true);
    }
  }, [checkParams, paramsChecked]);

  return (
    <>
      <div className='roomlist-view home-view' style={{ zIndex: 5 }}>
        <div className='home-panel'>
          <div className='home-hero'>
            <p className='home-tagline'>Replay tools for competitive Haxball</p>
            <h1>
              <span>Haxball Replay Analyzer</span>
              <span className='home-version-badge'>v{version}</span>
            </h1>
            <p className='home-description'>Break down matches with visual stats, timelines, and shareable clips designed for leagues and community play.</p>
          </div>
          <div className='home-actions'>
            <div className='home-upload'>
              <label htmlFor='replayfile' className='home-upload-button'>
                <span className='home-upload-icon'>►</span>
                <span>Load replay</span>
              </label>
              <input
                id='replayfile'
                type='file'
                accept='.hbr2'
                data-hook='replayfile'
                onChange={handleChange}
              />
            </div>
            <div className='home-links'>
              <button data-replays-type='mostViewed' onClick={showReplays}>
                <span className='home-link-icon'>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </span>
                <span>Most viewed replays</span>
              </button>
              <button data-replays-type='latest' onClick={showReplays}>
                <span className='home-link-icon'>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </span>
                <span>Latest replays</span>
              </button>
            </div>
          </div>
          <div
            className={`home-drop-zone${isDragActive ? ' is-active' : ''}`}
            onDragEnter={handleDragOver}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDropFile}
            onClick={() => document.getElementById('replayfile')?.click()}
          >
            <span className='home-drop-icon'>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </span>
            <span className='home-drop-text'>
              {isDragActive
                ? 'Drop file here to start analyzing!'
                : 'Drop a .hbr2 replay here or use the loader to start analyzing immediately.'}
            </span>
          </div>
          <div className='home-features'>
            {HOME_FEATURES.map((feature) => (
              <div className='home-feature-card' key={feature.title}>
                <div className='home-feature-header'>
                  {feature.icon && <span className='home-feature-icon'>{feature.icon}</span>}
                  <h3>{feature.title}</h3>
                </div>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <div className='home-contact'>
            <div className='home-contact-primary'>
              <span className='home-contact-label'>Need help?</span>
              <span>Discord: faissalinho · <a href='https://discord.gg/wRdMr9xqVj' target='_blank' rel='noopener noreferrer'>discord.gg/wRdMr9xqVj</a></span>
              <span className='home-credits'>Credits: Falafel</span>
            </div>
            <a
              className='home-contact-invite'
              href='https://discord.com/oauth2/authorize?client_id=1419344904869380128&permissions=311385246848&integration_type=0&scope=bot%20applications.commands'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img src={haxgptLogo} alt='HaxGPT logo' />
              <span>Invite HaxGPT to your Discord</span>
            </a>
          </div>
        </div>
      </div>
      <Downloading />
      <LoadingScreen />
      <ReplayPlayerOverlay />
      {clipControls}
      {mainMode === 'stats' && <GameStats replayId={replayId} />}
      {mainMode === 'replays' && <ReplaysList />}
    </>
  );
}

export default Home;

export { sanitizeMatchForUpload };
